<template>
  <div :class="!isSubtype && showBackgroundColor ? 'bg-grey-4' : ''" :id="'frmContent_' + objClassID" v-if="formularList" @input.capture="onUserInput"> <!-- :class="{'q-pt-lg':padding}" -->

    <OCRScanDialog :formProperty="ocrScanFormProperty" :showDlg="ocrDialogVisible" @dlgClose="ocrScanDialogClose" @ocrDone="ocrDone"/>
    <!--     page: {{ page }} / {{ actEditTab}}-->
    <!--    frm readonly: {{ readonly }} propReadonly: {{ propReadonly }}&lt;!&ndash; actionReadonly: {{ actionReadonly }}-->
    <!--    {{ pendingOperations }}, btnNextDisabled: {{ btnNextDisabled }}, btnNextDisabledParam {{ btnNextDisabledCauseParameter}}-->
    <q-layout ref="formLayout" v-if="!isSubtype" view="hHh lpR fff" container :style="{height: contentHeight + 'px'}" class="q-pa-none q-ma-none column no-wrap">
      <q-header v-if="maxPages>1" class="bg-grey-2" :class="{ subType: isSubtype, readOnly: readonly, 'q-pa-sm':padding }"> <!-- 'q-pt-lg':padding -->
        <q-tabs v-model="page" dense align="left" class="bg-grey-2 text-grey-7" active-color="secondary" :v-scroll="false">
          <q-tab v-if="formPrefix.length>0" v-for="(singleFormular, pageID) in formularList" :name="pageID" v-html="getFormularTab(singleFormular)"
                 :v-scroll="false" :class="'tab' + singleFormular.name + (actEditTab===pageID?' text-bold bg-primary text-white':'')"
                 @click="clickTab(singleFormular)" :disable="isTabDisabled(singleFormular)"
          /> <!-- @click="clickTab(singleFormular)" :disable="isTabDisabled(singleFormular)" -->
          <q-tab v-else v-for="(singleFormular, pageID) in formularList" :name="pageID" :label="getFormularTab(singleFormular)" :v-scroll="false"/>
        </q-tabs>
      </q-header>

      <q-page-container :id="'frmPage_' + objClassID" :class="{subType: isSubtype, readOnly: readonly, 'q-pa-lg':padding}" class="no-border"
                        :style="{ 'user-select': 'text', display: 'flex', 'flex-direction': 'column', overflow: 'auto', 'padding-bottom': maxPages > 1 ? footerH + 'px' : '0', flex: '1', 'min-height': '0' }"
                        v-if="formularList[page]">
        <div v-for="(singleFormular, pageID) in formularList" :key="pageID" v-show="page === pageID" style="flex: 1 0 auto;"> <!--  :class="{ 'q-pt-md' : maxPages>1 && !isPopup}" -->
          <!--          {{ pageID}} : {{ groupedFormularFields[pageID] }}-->
          <div class="row">
            <div :id="'frmHead_' + objClassID" class="col">
              <template v-if="isPopup">
                <p class="entryTextsm" v-if="!isSubtype"><span v-html="formularList[page].entryText"/></p>
              </template>
              <template v-else-if="propAppMode">
                <h3 class="frmH3sm" v-if="!isSubtype">{{ replaceFieldPlaceholder(formularList[page].title) }}</h3>
                <p class="entryTextsm q-mb-sm" v-if="!isSubtype"><span v-html="replaceFieldPlaceholder(formularList[page].entryText)"/></p>
              </template>
              <template v-else>
                <h3 class="frmH3" v-if="!isSubtype">{{ replaceFieldPlaceholder(formularList[page].title) }}
                  <q-icon
                    class="cursor-pointer"
                    name="keyboard_arrow_down"
                    @click="toggleCollapseAllPanels()"
                    color="primary"
                    :style="{ transform: collapseAllPanels[singleFormular.id] ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }"
                  />
                </h3>
                <p class="entryText" v-if="!isSubtype"><span v-html="replaceFieldPlaceholder(formularList[page].entryText)"/></p>
              </template>
              <div style="clear:both"></div>
            </div>
            <div class="col-auto items-end" v-if="objClassID==='{A90CD2DC-32A6-11EE-833D-309C23AC5997}' && formPrefix.length>1">
              <q-btn-group outline class="gt-md q-mt-md bg-white">
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnTTToggle')" class="q-px-sm">
                  <template v-if="isTTTaskRunning==='1'">
                    <q-icon name="stop_circle" class="q-mr-xs text-red"/>
                    <q-tooltip>Zeitaufzeichnung STOP</q-tooltip>
                    <span class="text-red">ZA</span>
                  </template>
                  <template v-else>
                    <q-icon name="play_circle" class="q-mr-xs"/>
                    <q-tooltip>Zeitaufzeichnung START</q-tooltip>
                    ZA
                  </template>
                </q-btn>
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnTTTaskList')" class="q-px-sm">
                  <q-icon name="access_time" class="q-mr-xs"/>
                  <q-tooltip>Gebuchte Stunden zu diesem Projekt anzeigen</q-tooltip>
                </q-btn>
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnQRLink')" class="q-px-sm">
                  <q-icon name="qr_code_scanner" class="q-mr-xs"/>
                  <q-tooltip>QR-Code zu diesem Auftrag generieren</q-tooltip>
                </q-btn>
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnReeferOnline')" class="q-px-sm">
                  <q-icon name="mdi-wifi-arrow-up-down" class="q-mr-xs"/>
                  <q-tooltip>Reefer Online im Fenster öffnen</q-tooltip>
                  Reefer Online
                </q-btn>
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnReeferStatus')" class="q-px-sm">
                  <img width="16" src="/statics/img/svg/sk_check_blue.svg" class="q-mr-xs"/>
                  <q-tooltip>Prüfbuch im Fenster öffnen</q-tooltip>
                  Prüfbuch
                </q-btn>
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnReeferSvcbook')" class="q-px-sm">
                  <q-icon name="construction" class="q-mr-xs"/>
                  <q-tooltip>Servicebuch im Fenster öffnen</q-tooltip>
                  Servicebuch
                </q-btn>
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnManual')" class="q-px-sm">
                  <q-icon name="menu_book" class="q-mr-xs"/>
                  <q-tooltip>Manual zu dieser Anlage öffnen (falls vorhanden)</q-tooltip>
                  Manual
                </q-btn>
                <q-btn outline color="primary" @click="clickFrmTitleButton('btnVehicleBaseEdit')" class="q-px-sm">
                  <q-icon name="mdi-database-settings" class="q-mr-xs"/>
                  <q-tooltip>Stammdaten zu dieser Anlage öffnen</q-tooltip>
                  Stammdaten
                </q-btn>
              </q-btn-group>
              <q-btn-dropdown dense flat icon="more_vert" class="custom-dropdown lt-lg q-mt-md">
                <q-list>
                  <q-item clickable v-ripple @click="clickFrmTitleButton('btnTTStart')" v-close-popup>
                    <q-item-section avatar>
                      <q-icon name="play_circle" style="color: red"/>
                    </q-item-section>
                    <q-item-section>Zeitaufzeichnung START</q-item-section>
                  </q-item>
                  <q-item clickable v-ripple @click="clickFrmTitleButton('btnTTEnd')" v-close-popup>
                    <q-item-section avatar>
                      <q-icon name="stop_circle" style="color: green"/>
                    </q-item-section>
                    <q-item-section>Zeitaufzeichnung ENDE</q-item-section>
                  </q-item>
                  <q-item clickable v-ripple @click="clickFrmTitleButton('btnQRLink')" v-close-popup>
                    <q-item-section avatar>
                      <q-icon name="qr_code_scanner" color="primary"/>
                    </q-item-section>
                    <q-item-section>QR-Code generieren</q-item-section>
                  </q-item>
                  <q-item clickable color="primary" @click="clickFrmTitleButton('btnReeferOnline')" v-close-popup>
                    <q-item-section avatar>
                      <q-icon name="mdi-wifi-arrow-up-down" color="primary"/>
                    </q-item-section>
                    <q-item-section>Reefer Online</q-item-section>
                  </q-item>
                  <q-item clickable color="primary" @click="clickFrmTitleButton('btnReeferStatus')" v-close-popup>
                    <q-item-section avatar>
                      <img width="16" src="/statics/img/svg/sk_check_blue.svg"/>
                    </q-item-section>
                    <q-item-section>Prüfbuch</q-item-section>
                  </q-item>
                  <q-item clickable color="primary" @click="clickFrmTitleButton('btnReeferSvcbook')" v-close-popup>
                    <q-item-section avatar>
                      <q-icon name="construction" color="primary"/>
                    </q-item-section>
                    <q-item-section>Servicebuch</q-item-section>
                  </q-item>
                  <q-item clickable color="primary" @click="clickFrmTitleButton('btnManual')" v-close-popup>
                    <q-item-section avatar>
                      <q-icon name="menu_book" color="primary"/>
                    </q-item-section>
                    <q-item-section>Manual</q-item-section>
                  </q-item>
                  <q-item clickable color="primary" @click="clickFrmTitleButton('btnVehicleBaseEdit')" v-close-popup>
                    <q-item-section avatar>
                      <q-icon name="mdi-database-settings" color="primary"/>
                    </q-item-section>
                    <q-item-section>Stammdaten</q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
          </div>

          <div :key="keyFormular">
            <div class="row q-col-gutter-xs-md" :class="{formular: !isSubtype}">
              <!-- Fieldgroups abc -->
              <div v-for="(firstFormPropertyInGroup, idx) in getFilteredFormularFields(singleFormular)" :class="getGroupClass(firstFormPropertyInGroup, true)" :key="firstFormPropertyInGroup.id"
                   v-show="showGroup(firstFormPropertyInGroup.fieldgroupTitle, page)">
                <q-expansion-item
                  :label="firstFormPropertyInGroup.fieldgroupTitle"
                  :model-value="isFieldgroupFormularExpanded(firstFormPropertyInGroup.id, null, null, null)"
                  @update:model-value="toggleFieldgroupFormularCollapse(firstFormPropertyInGroup.id, null, null, null)"
                  header-class="text-primary text-bold panelHeaderStyle"
                  :class="'frmCard ' + getCSSClassnameFromTitle(firstFormPropertyInGroup.fieldgroupTitle)"
                  v-if="firstFormPropertyInGroup.fieldgroupTitle!==''"
                  dense
                >
                  <div :class="!isSubtype ? 'q-pa-sm q-pt-md' : ''"> <!-- :class="(readonly || actionReadonly)?'':'q-pb-none'" -->
                    <div class="row q-col-gutter-x-lg">
                      <template v-for="formularField in singleFormular.formularFields.formularFlatList" :key="formularField.id" :class="{'q-py-sm': !isSubtype && !singleFormular.compressedView}">
                        <component ref="cmpFrmField" :is="formularField.component" v-if="formularField.fieldgroupTitle===firstFormPropertyInGroup.fieldgroupTitle && !formularField.systemParameter"
                                   v-show="(formularField.renderOnFrontend && (formularField.showThroughDependency === true || formularField.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))"
                                   :formProperty="formularField" @onChange="onFieldValueChange($event, formularField)" :queryID="queryID" :selectedRow="selectedRow"
                                   :parentFormularID="singleFormular.id"
                                   :compressed="singleFormular.compressedView" :formularList="formularList" :readOnly="readonly || actionReadonly" :inGroupCard="true" @useOCRScanDialog="useOCRScanDialog"/>
                      </template>
                    </div>
                  </div>
                </q-expansion-item>
                <template v-else v-for="formularField in singleFormular.formularFields.formularFlatList" :key="formularField.id" :class="{'q-py-sm': !isSubtype && !singleFormular.compressedView}">
                  <!-- Subformular Fields with NO Fieldgroup -->
                  <component ref="cmpFrmField" :is="formularField.component" v-if="formularField.fieldgroupTitle==='' && !formularField.systemParameter"
                             v-show="(formularField.renderOnFrontend && (formularField.showThroughDependency === true || formularField.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))"
                             :formProperty="formularField" @onChange="onFieldValueChange($event, formularField)" :queryID="queryID" :selectedRow="selectedRow"
                             :parentFormularID="singleFormular.id"
                             :compressed="singleFormular.compressedView" :formularList="formularList" :readOnly="readonly || actionReadonly" :inGroupCard="true" @useOCRScanDialog="useOCRScanDialog"/>

                </template>
              </div>
            </div>
          </div>
          <br v-if="!isSubtype"/>
        </div>
      </q-page-container>

      <!--
      * fixed footer wenn mehrere Formularseiten, hellgrauer Hintergrund (gleich wie Seitenhintergrund wenn nicht scrollbar), bg-grey-5 ist dünkleres grau
      *
      -->
      <q-footer :class="(maxPages > 1 ? 'fixed-bottom-footer' : 'sticky-footer') + ' ' + (isScrollable || maxPages > 1 ? 'bg-grey-5' : 'bg-grey-4')"
                :style="{ 'flex-shrink': '0', 'padding' : ($q.screen.xs || !isScrollable) ? '5px 23px 20px 0' : '15px 23px 20px 0', 'box-shadow': isScrollable ? '0 -4px 8px rgba(0,0,0,0.15)' : 'none' }"
                v-if="(!isPopup || popupButtonsInPanel) && btnTxtCommit && !isSubtype && !actionReadonly && formularList[page] && (!readonly || this.formPrefix.length>0)"> <!-- && !readonly -->
        <div class="row">
          <div :class="(getVisibleFormularGroups(formularList[page]).length === 1 && maxPages === 1 && !$q.screen.xs && !singleGroupFullWidth ? 'col-6' : 'col-12') + ' justify-end'">
            <!-- Speichern -->
            <q-btn size="md" class="float-right on-right " unelevated :disabled="btnNextDisabled" color="primary" @pointerdown="btnCommit()" @keyup.enter="btnCommit()" @keyup.space="btnCommit()" v-if="formularList[page].aheadCommitAllowed" data-test="commitForm">
              <span v-if="maxPages === 1 || $q.screen.gt.xs">{{ btnTxtCommit }}</span>
              <span v-if="maxPages > 1 && $q.screen.xs">OK</span>
              <q-tooltip>Formular speichern & schließen</q-tooltip>
            </q-btn>

            <!-- Abbrechen -->
            <q-btn size="md" v-if="showCancel" style="border:1px solid #aaa !important;background-color: #999 !important;" unelevated class="float-right on-right q-ml-lg" @click="!isPopup && !propAppMode ? pageBack() : cancelPopup()">
              <span v-if="maxPages===1 || $q.screen.gt.xs" >Abbrechen</span>
              <span v-if="maxPages>1 && $q.screen.xs"><q-icon name="close"/></span>
              <q-tooltip>Formular OHNE speichern verlassen</q-tooltip>
            </q-btn>

            <q-btn size="md" :dense="$q.screen.lt.md" class="float-right on-right bg-white q-mr-xs" unelevated :color="btnNextStyle?'':'secondary'" @click="btnNext(maxPages>1 && (page === (maxPages-1))?1:0)" :style="btnNextStyle"
                   data-test="nextForm" v-if="maxPages>1" :disabled="btnNextDisabled || btnNextDisabledCauseParameter" :loading="pendingOperations > 0">
              <span v-if="maxPages>1 && page < (maxPages-1)">
                <span class="gt-xs">{{ btnTxtNext }}</span>
                <q-icon class="lt-sm" style="padding:3px 2px 3px 3px" name="arrow_forward_ios"/>
              </span>
              <span v-else>Abschließen

              </span>
              <q-tooltip>Formular verfizieren, speichern & schließen</q-tooltip>
            </q-btn>

            <q-btn size="md" :dense="$q.screen.lt.md" class="float-right on-right btnApply bg-white" :style="btnApplyStyle" unelevated :color="btnApplyStyle?'':'secondary'" @click="btnApply()" v-if="maxPages>1" data-test="nextForm">
              <span class="gt-xs">{{ btnTxtApply }}</span>
              <q-icon class="lt-sm" style="padding:3px 2px 3px 3px" name="save_alt"/>
              <q-tooltip>Formular speichern, auf Seite bleiben</q-tooltip>
            </q-btn>

            <q-btn size="md" :dense="$q.screen.lt.md" class="float-right on-right bg-white" :style="btnPrevStyle" :color="btnPrevStyle?'':'secondary'" unelevated @click="btnBack()" v-if="maxPages>1" :disabled="page===0">
              <span class="gt-xs">{{ btnTxtBack }}</span>
              <q-icon class="lt-sm" style="padding:3px 0 3px 5px" name="arrow_back_ios"/>
              <q-tooltip>Zurück zum vorherigen Schritt</q-tooltip>
            </q-btn>

            <q-btn v-if="formularClass.customAction0PluginID" size="md" class="float-right on-right q-mr-md" color="red-4" unelevated @click="callAction0Plugin" :label="formularClass.customAction0Title">
            </q-btn>
          </div>
        </div>
      </q-footer>
    </q-layout>

    <!-- *** Subformular Rendering -->
    <div v-else v-for="(firstFormPropertyInGroup, subFormIdx) in formularList" :key="subFormIdx" v-show="page === subFormIdx"> <!-- :class="{ 'q-pt-md' : formPrefix.length===0 && !isPopup}" -->
      <div class="row q-pb-md" :class="{formular: !isSubtype}">
        <!--        <template v-if="hasFormularGroups(firstFormPropertyInGroup)">-->
        <q-expansion-item
          :label="getSubformularGroupTitle(firstFormPropertyInGroup)==='' ? '--' : getSubformularGroupTitle(firstFormPropertyInGroup)"
          :model-value="isFieldgroupFormularExpanded(parentFormPropertyClassID, firstFormPropertyInGroup.id, subtypeIdx, null)"
          @update:model-value="toggleFieldgroupFormularCollapse(parentFormPropertyClassID, firstFormPropertyInGroup.id, subtypeIdx, null)"
          :header-class="'text-primary text-bold panelSubHeaderStyle ' + getSubformularCSSClass(firstFormPropertyInGroup)"
          class="frmSubCard"
          dense
        >
          <template v-if="hasFormularGroups(firstFormPropertyInGroup)">
            <div class="row q-col-gutter-x-md q-pa-sm q-pt-md">
              <div v-for="(firstFormPropertyInGroupSubForm, idx) in getFilteredFormularFields(firstFormPropertyInGroup)" :class="getGroupClass(firstFormPropertyInGroupSubForm)" :key="firstFormPropertyInGroupSubForm.id"
                   v-show="showGroup(firstFormPropertyInGroupSubForm.fieldgroupTitle, page)">
                <!-- Fieldgroups in Subformular -->
                <q-expansion-item
                  :label="firstFormPropertyInGroupSubForm.fieldgroupTitle"
                  :model-value="isFieldgroupFormularExpanded(parentFormPropertyClassID, firstFormPropertyInGroup.id, subFormIdx, firstFormPropertyInGroupSubForm.id)"
                  @update:model-value="toggleFieldgroupFormularCollapse(parentFormPropertyClassID, firstFormPropertyInGroup.id, subFormIdx, firstFormPropertyInGroupSubForm.id)"
                  v-if="firstFormPropertyInGroupSubForm.fieldgroupTitle!==''"
                  header-class="text-primary text-bold panelHeaderStyle"
                  :class="'frmCard ' + getCSSClassnameFromTitle(firstFormPropertyInGroupSubForm.fieldgroupTitle)"
                  dense
                >
                  <div class="row q-col-gutter-x-md q-pa-sm q-pt-md">
                    <template v-for="formularField in firstFormPropertyInGroup.formularFields.formularFlatList" :key="formularField.id" :class="{'q-py-sm': !isSubtype && !firstFormPropertyInGroup.compressedView}">
                      <component ref="cmpFrmField" :is="formularField.component" v-if="formularField.fieldgroupTitle===firstFormPropertyInGroupSubForm.fieldgroupTitle && !formularField.systemParameter"
                                 v-show="(formularField.renderOnFrontend && (formularField.showThroughDependency === true || formularField.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))"
                                 :formProperty="formularField" @onChange="onFieldValueChange($event, formularField)" :queryID="queryID" :selectedRow="selectedRow"
                                 :compressed="firstFormPropertyInGroup.compressedView" :formularList="formularList" :readOnly="readonly || actionReadonly" :inGroupCard="true" @useOCRScanDialog="useOCRScanDialog"/>
                    </template>
                  </div>
                </q-expansion-item>
                <!-- no fieldgroups mixed in subformular -->
                <template v-else v-for="formularField in firstFormPropertyInGroup.formularFields.formularFlatList" :key="formularField.id" :class="{'q-py-sm': !isSubtype && !firstFormPropertyInGroup.compressedView}">
                  <component ref="cmpFrmField" :is="formularField.component" v-if="formularField.fieldgroupTitle==='' && !formularField.systemParameter"
                             v-show="(formularField.renderOnFrontend && (formularField.showThroughDependency === true || formularField.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))"
                             :formProperty="formularField" @onChange="onFieldValueChange($event, formularField)" :queryID="queryID" :selectedRow="selectedRow"
                             :compressed="firstFormPropertyInGroup.compressedView" :formularList="formularList" :readOnly="readonly || actionReadonly" :inGroupCard="true" @useOCRScanDialog="useOCRScanDialog"/>

                </template>
              </div>
            </div>
          </template>
          <div v-else class="row q-col-gutter-xs-x-sm q-col-gutter-md-x-md q-pa-md">
            <!-- no fieldgroups in whole formular -->
            <template v-for="formularField in firstFormPropertyInGroup.formularFields.formularFlatList" :key="formularField.id">
              <component ref="cmpFrmField" :is="formularField.component" v-if="formularField.fieldgroupTitle==='' && !formularField.systemParameter"
                         v-show="(formularField.renderOnFrontend && (formularField.showThroughDependency === true || formularField.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))"
                         :formProperty="formularField" @onChange="onFieldValueChange($event, formularField)" :queryID="queryID" :selectedRow="selectedRow"
                         :compressed="firstFormPropertyInGroup.compressedView" :formularList="formularList" :readOnly="readonly || actionReadonly" :inGroupCard="true" @useOCRScanDialog="useOCRScanDialog"/>
            </template>
          </div>
        </q-expansion-item>
      </div>
    </div>

    <q-dialog v-model="showMultiSubmitProgress" :persistent="false">
      <q-card style="width:50vw">
        <q-linear-progress rounded size="25px" :value="multiSubmitCounter/multipleSubmitCount" color="primary">
          <div class="absolute-full flex flex-center">
            <q-badge color="white" text-color="primary" :label="multiSubmitCounter + '/' + multipleSubmitCount"/>
          </div>
        </q-linear-progress>
      </q-card>
    </q-dialog>

    <component :is="pluginComponent" :queryParams="pluginComponentQueryParams"/>
  </div>
</template>

<script>
import FormProperty from '../classes/FormProperty'
import {StaticData} from '../classes/StaticData'
import HistoryBack from "components/plugins/netzportal/HistoryBack"
import URLHelper from '../classes/URLHelper'
import CSVHelper from "../classes/CSVHelper";
import DOMHelper from "../classes/DOMHelper";
import {dialogAvailableHeight} from 'src/classes/DialogLayout.js'
import {singleGroupFullWidth, fieldGroupClass} from 'src/classes/FormularLayout.js'
import DatatypeHelper from "../classes/DatatypeHelper";
import FormularHelper from "../classes/FormularHelper";
import {useFormularStore} from 'src/stores/FormularStore.js'
import {useAuthStore} from "src/stores/AuthStore";
import {scroll} from 'quasar'
import OCRScanDialog from "components/forms/OCRScanDialog.vue";

const {getScrollTarget, setVerticalScrollPosition} = scroll

export default {
  name: 'formular',
  props: {
    propObjClassID: String,
    propSelectedRow: String,
    isSubtype: Boolean,
    subtypeIdx: Number,
    focusInSubtype: Boolean,
    propHeight: Number,
    subObjInstanceID: String,
    subtypeCount: Number,
    propSelectedMultiple: Boolean,
    propAppMode: Boolean,
    parentFormPointer: Object,
    parentFormPropertyClassID: String,
    parentFormularID: String,
    propReadonly: Boolean,
    isPopup: Boolean,
    popupButtonsInPanel: Boolean,
    popupAutoclose: Boolean,
    popupOiID: String,
    popupSuccessPage: String,
    receivedActionButtonClick: Object,
    // formular inside a resultset action dialog (#897): Save closes, Apply keeps the dialog open
    actionDialog: Boolean,
    padding: {
      Boolean,
      default: true
    },
    showCancel: {
      Boolean,
      default: true
    },
    showBackgroundColor: {
      Boolean,
      default: true
    }
  },
  components: {OCRScanDialog, HistoryBack},
  data() {
    const newVar = {
      StaticData,
      objClassID: this.isSubtype ? this.propObjClassID : this.propObjClassID ? this.propObjClassID : this.$route.params.contentid,
      origObjClassID: '?',
      formularWidth: null, // measured width of the formular layout (single group full width when narrow)
      queryID: this.$route.params.id,
      queryParameter: safeParseJSON(history.state.queryParameter),
      // filled ojbInstanceID forces MP to load propertyinstances - so formular will be prefilled
      objInstanceID: !this.isPopup ? (this.subObjInstanceID ? this.subObjInstanceID : history.state.objInstanceID && !this.isSubtype ? history.state.objInstanceID : this.$route.query.oiID && !this.isSubtype ? this.$route.query.oiID : !this.isSubtype ? this.$route.query["qp.oiID"] : null) : this.popupOiID,
      selectedRow: this.propSelectedRow ? safeParseJSON(this.propSelectedRow) : safeParseJSON(history.state.selectedRow),
      selectedMultiple: history.state.selectedMultiple ? safeParseJSON(history.state.selectedMultiple) : this.propSelectedMultiple ? this.propSelectedMultiple : null,
      readonly: DatatypeHelper.toBoolean(this.propReadonly),
      postAction: history.state.postAction,
      activeFormularList: null, // format: showForms={ objClass : [frmID1, frmID2, frmID3]}
      multipleSubmitCount: 0,
      multiSubmitCounter: 0,
      showMultiSubmitProgress: false,
      actionReadonly: history.state.readonly === true || history.state.readonly === 'true' ? true : false,
      contentHeight: 600,
      footerH: 0,

      formularClass: null,
      pluginList: null,
      pluginComponent: null,
      pluginComponentQueryParams: null,
      formularList: [{formularFields: {formularFlatList: []}}],
      page: 0,
      minPages: 0,
      maxPages: 0,
      btnNextDisabledCauseParameter: false,
      formPrefix: [],
      btnCommitFunc: 0, // 0 = Save & Close, 1 = Apply, 2 = Next, 3 = Back
      actionDialogDirty: false, // unsaved user input in an action dialog
      actionDialogReady: false, // ignore value changes caused by initial loading

      firstFieldWithError: null,
      firstPageWithError: null,
      paramsInvalid: false,
      formularPageValid: [], // array of booleans - index is formulare page (if any), true = page is valid, false = page is invalid
      paramsPreSave: false,
      preSafePromises: [],
      preSafeFields: [],
      keyFormular: 0,
      btnTxtCommit: null,
      btnTxtNext: null,
      btnTxtApply: null,
      btnTxtBack: null,
      drawnFieldGroups: [],
      actionParameter: {objClassID: '', formCSS: ''},
      subclassTypecounter: 0,
      subclassEventcounter: 0,
      possibleSubclassCounter: 0, //all possible subclasses not just active ones
      isShowingEmptyLazyDialog: false,
      btnNextStyle: PP_CONST.APP_THEME[PP_CONST.APP_ACTIVE].STYLE_BTN_NEXT,
      btnPrevStyle: PP_CONST.APP_THEME[PP_CONST.APP_ACTIVE].STYLE_BTN_PREV,
      btnApplyStyle: PP_CONST.APP_THEME[PP_CONST.APP_ACTIVE].STYLE_BTN_APPLY,
      // loading: false
      onCommitParentFromEvent: false,
      ocrScanFormProperty: null,
      ocrDialogVisible: false,
      posFirstRedTabOnFirstOpenDone: false,
      actEditTab: 0,
      formularStore: useFormularStore(),
      isTTTaskRunning: null,
      collapseAllPanels: [], // [ formularID : true/false ]
      isScrollable: false,
      formularFieldgroupCollapsed: [] // { formPropertyID : "", subFormularID: "", formPropertySubForm: "", idx: 0 }
    };
    return newVar
  },

  computed: {
    // only field group of a single-page formular spans the full width when the formular itself is narrow
    singleGroupFullWidth() {
      const formular = this.formularList && this.formularList[this.page]
      return singleGroupFullWidth({
        isSubtype: this.isSubtype,
        maxPages: this.maxPages,
        visibleGroupCount: formular ? this.getVisibleFormularGroups(formular).length : 0,
        width: this.formularWidth
      })
    },

    // Reaktive Verbindung zum pendingOperations im Store
    pendingOperations() {
      return this.formularStore.pendingOperations
    },
    btnNextDisabled() {
      return this.pendingOperations > 0
    },
    isTTTaskRunningField() {
      const flatList = this.formularList?.[this.maxPages - 1]?.formularFields?.formularFlatList
      return flatList?.find(field => field.nativename === "isTTTaskRunning")
    },

    /*    groupedFormularFields() {
          if (!this.formularList) return []

          return this.formularList.map(formPage => {
            const groups = new Map()
            const flatList = formPage?.formularFields?.formularFlatList
            if (!flatList) return []

            // Identify unique active groups and their first fields
            flatList.forEach(field => {
              if (!field.active || !field.renderOnFrontend) return

              const title = field.fieldgroupTitle || ""
              if (!groups.has(title)) {
                groups.set(title, {
                  title: title,
                  firstField: field, // For group properties/classes
                  fields: []
                })
              }
              groups.get(title).fields.push(field)
            })

            return Array.from(groups.values())
          })
        },*/

    subformularCSSClasses() {
      const classMap = new Map()
      if (!this.formularList) return classMap
      for (const formular of this.formularList) {
        const field = formular.formularFields?.formularFlatList?.find(
          f => f.nativename === formular.name
        )
        let cssClass = ""
        if (field?.value) {
          try {
            cssClass = JSON.parse(field.value).cssclass ?? ""
          } catch {
            // Invalid JSON, keep empty string
          }
        }
        classMap.set(formular.id, cssClass)
      }
      return classMap
    },

    subformularCollapse() {
      const collapseMap = new Map()
      if (!this.formularList) return collapseMap
      for (const formular of this.formularList) {
        const field = formular.formularFields?.formularFlatList?.find(
          f => f.nativename === formular.name
        )
        let collapse = false
        if (field?.value) {
          try {
            collapse = JSON.parse(field.value).collapse ?? false
          } catch {
            // Invalid JSON, keep empty string
          }
        }
        collapseMap.set(formular.id, collapse)
      }
      return collapseMap
    }
  },

  watch: {
    // action dialog: the dialog guards Escape / backdrop close only while there is unsaved input
    actionDialogDirty(dirty) {
      if (this.actionDialog && this.isPopup) this.$emit('initButtons', {formDirty: dirty})
    },

    receivedActionButtonClick(data) {
      // Do something when the received event changes
      //logger.info('Action button click from parent:', data.button);
      switch (data.button) {
        case 'commit':
        case 'commitNew':
          if (this.actionDialog) this.btnCommitFunc = 0
          this.btnCommit();
          break;
        case 'apply':
          this.btnApply();
          break;
        case 'next':
          this.btnNext();
          break;
        case 'back':
          this.btnBack();
          break;
        case 'close':
          this.cancelPopup();
          break;
      }
    },

    'formularList': {
      handler(newValue) {
        this.checkScrollable()
        const flatList = this.formularList?.[this.page]?.formularFields?.formularFlatList
        if (!flatList) {
          this.btnNextDisabledCauseParameter = false
          return
        }

        this.btnNextDisabledCauseParameter = flatList.some((field) => {
          if (!field.value || !field.showThroughDependency) return false

          const fieldValue = String(field.value)
          if (!fieldValue.includes("btnNextDisable")) return false

          const params = new URLSearchParams(fieldValue)
          return params.get("btnNextDisable") === "1"
        })
      },
      deep: true, // Needed to detect changes in nested objects/arrays
      flush: 'post'
    },

    'isTTTaskRunningField.value': {
      handler(newValue) {
        this.isTTTaskRunning = newValue
      },
      immediate: true
    }
  },

  methods: {
    checkScrollable() {
      const container = document.getElementById('frmPage_' + this.objClassID)
      if (!container) return
      const headerH = this.$refs.formLayout?.$el?.querySelector('.q-header')?.offsetHeight ?? 0
      this.footerH = this.$refs.formLayout?.$el?.querySelector('.q-footer')?.offsetHeight ?? 0
      this.isScrollable = container.scrollHeight + headerH + this.footerH > this.contentHeight
    },

    getSubformularCSSClass(formular) {
      return this.subformularCSSClasses.get(formular.id) ?? ""
    },

    isSubformularCollapsed(formular) {
      console.log("isSubformularCollapsed: ", this.subformularCollapse.get(formular.id) ?? false)
      return this.subformularCollapse.get(formular.id) ?? false
    },

    isFieldgroupFormularExpanded(formPropertyID, subFormularID, subFormIdx, formPropertySubForm) {
      let collapsed = this.formularFieldgroupCollapsed.filter(f => f.formPropertyID === formPropertyID && f.subFormularID === subFormularID && f.formPropertySubForm === formPropertySubForm && f.subFormIdx === subFormIdx).length !== 0
      return !collapsed
    },

    toggleCollapseAllPanels(preventEventCall) {
      const currentFormularID = this.formularList[this.page].id

      this.collapseAllPanels[currentFormularID] = !this.collapseAllPanels[currentFormularID]
      const firstFieldOfFieldgroupsActForm = this.getFilteredFormularFields(this.formularList[this.page])

      for (let i = this.formularFieldgroupCollapsed.length - 1; i >= 0; i--) {
        if (this.formularFieldgroupCollapsed[i].formularID === currentFormularID) {
          this.formularFieldgroupCollapsed.splice(i, 1)
        }
      }

      if (this.collapseAllPanels[currentFormularID]) {
        if (firstFieldOfFieldgroupsActForm) {
          firstFieldOfFieldgroupsActForm.forEach((f, idx) => {
            this.formularFieldgroupCollapsed.push({formularID: currentFormularID, formPropertyID: f.id, subFormularID: null, subFormIdx: null, formPropertySubForm: null})
          })
        }
      }

      if (!preventEventCall) {
        this.eventBus.toggleCollapseAllPanels(currentFormularID, this.collapseAllPanels[currentFormularID])
      }
    },

    /**
     * Toggle subformular self - each subformular has only one one formular in it. fldSubtype renders <formular> als v-each
     * @param data
     */
    onToggleCollapseAllPanels(data) {
      const currentFormularID = this.formularList[this.page].id
      if (data.subFormularID === this.parentFormularID && data.subFormularID !== currentFormularID && this.isSubtype) {
        if (data.collapseAllPanels) {
          // collapse self
          this.formularFieldgroupCollapsed.push({formularID: currentFormularID, formPropertyID: this.parentFormPropertyClassID, subFormularID: currentFormularID, subFormIdx: this.subtypeIdx, formPropertySubForm: null})
        } else {
          for (let i = this.formularFieldgroupCollapsed.length - 1; i >= 0; i--) {
            if (this.formularFieldgroupCollapsed[i].formularID === currentFormularID) {
              this.formularFieldgroupCollapsed.splice(i, 1)
            }
          }
        }
      }
    },

    toggleFieldgroupFormularCollapse(formPropertyID, subFormularID, subFormIdx, formPropertySubForm) {

      this.toggleCollapseOnePanel(formPropertyID, subFormularID, subFormIdx, formPropertySubForm)

      if (!this.$q.platform.is.mobile) {
        let firstFieldOfFieldgroupsActForm = this.getFilteredFormularFields(this.formularList[this.page]).filter(f => this.showGroup(f.fieldgroupTitle, this.page) && f.fieldgroupTitle !== "")

        let searchForID = formPropertySubForm ? formPropertySubForm : formPropertyID
        const idx = firstFieldOfFieldgroupsActForm.findIndex(item => item.id === searchForID)

        if (idx % 2 === 0 && idx < firstFieldOfFieldgroupsActForm.length - 1) {
          // left panel
          let rightPanelFormPropertyID = firstFieldOfFieldgroupsActForm[idx + 1].id
          if (!formPropertySubForm) {
            this.toggleCollapseOnePanel(rightPanelFormPropertyID, subFormularID, subFormIdx, formPropertySubForm)
          } else {
            this.toggleCollapseOnePanel(formPropertyID, subFormularID, subFormIdx, rightPanelFormPropertyID)
          }

        } else if (idx % 2 === 1 && idx > 0) {
          // right panel
          let leftPanelFormPropertyID = firstFieldOfFieldgroupsActForm[idx - 1].id
          if (!formPropertySubForm) {
            this.toggleCollapseOnePanel(leftPanelFormPropertyID, subFormularID, subFormIdx, formPropertySubForm)
          } else {
            this.toggleCollapseOnePanel(formPropertyID, subFormularID, subFormIdx, leftPanelFormPropertyID)
          }
        }
      }
    },

    toggleCollapseOnePanel(formPropertyID, subFormularID, subFormIdx, formPropertySubForm) {
      let found = this.formularFieldgroupCollapsed.filter(f => f.formPropertyID === formPropertyID && f.subFormularID === subFormularID && f.formPropertySubForm === formPropertySubForm && f.subFormIdx === subFormIdx)
      if (found.length > 0) this.formularFieldgroupCollapsed.splice(this.formularFieldgroupCollapsed.indexOf(found[0]), 1)
      else this.formularFieldgroupCollapsed.push({formularID: this.formularList[this.page].id, formPropertyID, subFormularID, subFormIdx, formPropertySubForm})
    },

    getSubformularGroupTitle(formular) {
      let result = formular.title
      if (!result) result = this.parentFormPointer.title

      const match = result.match(/:(\w+)/)
      if (match) {
        const placeholder = match[1]
        let placeHolderFormField = formular.formularFields.formularFlatList.filter(f => f.nativename === placeholder)
        if (placeHolderFormField.length > 0 && placeHolderFormField[0].value) {
          result = result.replace(match[0], placeHolderFormField[0].value)
        } else {
          result = result.replace(match[0], "")
        }
      }
      return result
    },

    ocrDone(scanResult) {
      // logger.info("Formular.vue: OCR/QR/Barcode scan result:", this.ocrScanFormProperty, scanResult)
      this.eventBus.refreshCompDefault(null, this.ocrScanFormProperty.nativename, scanResult, this.ocrScanFormProperty.defaultValue, '', '', this.ocrScanFormProperty.subtypeCount, this.ocrScanFormProperty.nativename)
      this.ocrScanDialogClose()
    },
    ocrScanDialogClose() {
      this.ocrDialogVisible = false
    },
    useOCRScanDialog(data) {
      console.info('[OCR] Scan-Anfrage wurde von Formular.vue empfangen', {
        ocrType: data.formProperty?.ocrType,
        field: data.formProperty?.nativename
      })
      this.ocrScanFormProperty = data.formProperty
      this.ocrDialogVisible = true
      data.onDialogOpened?.()
    },

    clickTab(clickedFormular) {
      // { "name": "frmOpenTS_prefix", "value": "<img class=\"chksvgForm\" src=\"https://www.servoking.at/sitemedia/icons/sk_check_green.svg\"/>" }
      let firstRedFormular = this.formPrefix.find(entry => {
        if (entry.value) {
          return entry.value.includes("red")
        }
      })
      if (firstRedFormular) {
        let frmPrefix = this.formPrefix.filter(entry => entry.name.includes(clickedFormular.name))
        if (frmPrefix[0].value.includes("green") && frmPrefix[0].name !== firstRedFormular.name) this.readonly = true
        else this.readonly = false
      } else {
        this.readonly = true
      }
      this.scrollToTop()
    },


    getCSSClassnameFromTitle(title) {
      return FormularHelper.getCSSClassnameFromTitle(title)
    },

    scrollToTop() {
      const el = document.getElementById("frmPage_" + this.objClassID)
      const target = getScrollTarget(el)
      setVerticalScrollPosition(target, 0, 0)
    },

    isTabDisabled(clickedFormular) {
      let firstRedFormular = this.formPrefix.find(entry => entry.value.includes("red"))
      let frmPrefix = this.formPrefix.filter(entry => entry.name.includes(clickedFormular.name))
      return frmPrefix[0].value.includes("red") && frmPrefix[0].name !== firstRedFormular.name
    },

    getActiveTab() {
      // logger.info("getActiveTab")
      if (!this.posFirstRedTabOnFirstOpenDone) {
        // on FIRST open of this formular instance - position active tab in first red on
        let i = 0
        for (i = 0; i < this.formPrefix.length; i++) {
          if (this.formPrefix[i].value && this.formPrefix[i].value.includes("red")) {
            break
          }
        }
        if (i === this.formPrefix.length) i = this.formPrefix.length - 1
        this.posFirstRedTabOnFirstOpenDone = true
        // logger.info("get first RED Tab", i < 0 ? 0 : i)
        return i < 0 ? 0 : i

      } else {
        // normal reload after first open - stay on same page
        return this.actEditTab
        /*
                let i = 0
                for (i = this.formPrefix.length - 1; i > 0; i--) {
                  if (this.formPrefix[i].value && this.formPrefix[i].value.includes("green")) {
                    break
                  }
                }
                // logger.info("get last GREEN Tab", i + 1)
                return i + 1
        */
      }
    },

    getFilteredFormularFields(formular) {
      let res = []
      // console.log("getFilteredFormularFields: ", formular.formularFields)
      for (let field of formular.formularFields.formularFlatList) {
        if (res.some(f => f.fieldgroupTitle === field.fieldgroupTitle) || !field.active) {
          continue
        }
        res.push(field)
      }
      return res
    },

    getVisibleFormularGroups(formular) {
      let res = []
      for (let field of formular.formularFields.formularFlatList) {
        if (res.some(f => f.fieldgroupTitle === field.fieldgroupTitle) || !field.active || !field.renderOnFrontend) {
          continue
        }
        res.push(field)
      }
      return res
    },

    resetValidationData() {
      const formStore = useFormularStore()
      this.firstFieldWithError = null
      this.firstPageWithError = null
      this.btnNextDisabled = false
      this.paramsInvalid = false
      this.paramsPreSaveInvalid = false
      this.preSafePromises = []
      this.preSafeFields = []
      formStore.fileUploadPromises = []
    },

    resetValidationDataNoUploads() {
      this.firstFieldWithError = null
      this.firstPageWithError = null
      this.btnNextDisabled = false
      this.paramsInvalid = false
      this.paramsPreSaveInvalid = false
      this.preSafePromises = []
      this.preSafeFields = []
    },

    validateOnly() {
      logger.info("validateOnly")
      this.resetValidationDataNoUploads()

      this.formularList.forEach((formList, pageIndex) => {
        formList.formularFields.formularFlatList.forEach((field) => this.validateField(field, pageIndex))
      })
      if (this.preSafePromises.length > 0) {
        this.checkPreSafeSQL(this.commitData)
      }

      let invalidEagerinSub = 0;
      let invalidLazyinSub = 0;
      let invalidEmptyLazyinSub = 0;
      let invalidGeneralinSub = 0;

      this.formularList.forEach((formList) => {
        formList.formularFields.formularFlatList.forEach((field) => {
          // logger.info("commitData check: ", field.title, field.invalid, field.requiredMode)
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER) {
            logger.info("validateOnly 1- invalidEagerReqModeFields  (validate only)=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value);
            invalidEagerinSub++
          }
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
            invalidLazyinSub++
            if (!field.value) invalidEmptyLazyinSub++
            logger.info("validateOnly 2 - invalidLazyReqModeFields=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value);
          }
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.NONE && field.dataTypeID !== StaticData.DATATYPES.TYPE_SUBCLASS) {
            console.warn("validateOnly 3 - invalidGeneralFields (validate only)=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value);
            invalidGeneralinSub++
          }
        })
      })

      if (invalidEagerinSub > 0 || invalidGeneralinSub > 0) {
        return null
      } else {
        if (invalidLazyinSub > 0 && invalidEmptyLazyinSub) {
          this.eventBus.subformularInvalidLazy(invalidLazyinSub, this.parentFormPointer.formObjectClassID)
          this.formularList.invalidLazyinSub = true
        }
        return this.formularList
      }
    },

    btnCopyFields() {
      let copyBoxElement = document.getElementsByClassName('formular')[0];

      // Create a range object and select the contents of the div
      const range = document.createRange();
      range.selectNodeContents(copyBoxElement);

      // Create a new selection and add the range to it
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      // Copy the selected content to the clipboard
      document.execCommand('copy');

      // Clean up the selection
      selection.removeAllRanges();
    },

    async btnApply(data) {
      this.btnCommitFunc = 1

      if (data && data.commitParentObjClassID === this.objClassID) {
        this.onCommitParentFromEvent = true
        this.btnCommit()
        // this.onCommitParentFromEvent = false

        // open popup after commit (startet in fldString)
        this.eventBus.openPopup(data.formProperty);
      }

      if (!data) {
        this.btnCommit()
      }
    },

    async btnCommit() {
      // logger.info("btnCommit")
      this.normalizeDateTimeInputs()
      await this.$nextTick()
      this.resetValidationData()

      this.formularList.forEach((formList, pageIndex) => {
        formList.formularFields.formularFlatList.forEach((field) => this.validateField(field, pageIndex))
      })

      this.addUploadAndPreSafePromisesToField()

      if (this.preSafePromises.length > 0) {
        this.checkPreSafeSQL(this.commitData)
      } else {
        this.commitData()
      }
    },

    normalizeDateTimeInputs() {
      this.eventBus.emit('onNormalizeDateTimeInput')
    },

    btnNext(fnClose) {
      this.resetValidationData()

      // validate fields of current page
      this.formularList[this.page].formularFields.formularFlatList.forEach((field) => this.validateField(field, this.page))
      logger.info("btnNext validateField paramsInvalid: ", this.paramsInvalid)

      if (this.preSafePromises.length > 0) {
        this.checkPreSafeSQL(this.gotoNextPage)

      } else {
        if (!this.paramsInvalid) {
          if (this.formPrefix && this.formPrefix.length >= this.page && this.formPrefix[this.page]) this.formPrefix[this.page].value = "<img class='chksvgForm' src='https://snippet.servoking.at/sitemedia/icons/sk_check_green.svg'/>"
          this.readonly = false
        }

        if (this.formPrefix.length === 0) this.gotoNextPage()
        else if (!this.paramsInvalid) {
          if (fnClose) this.btnCommitFunc = 0 // save & exit
          else this.btnCommitFunc = 2 // only save, stay in formular - but increase page after persist

          this.btnCommit()

        } else {
          // this.btnCommitFunc = 1 // apply, stay on page - only save
          // this.btnCommit()
          if (this.firstFieldWithError != null) this.eventBus.setFocus(this.firstFieldWithError.nativename)
        }
      }

      if (this.isPopup) {
        this.$emit("initButtons", {
          page: this.page
        })
      }
    },

    /**
     * Called after click on the NEXT Button
     *
     * @param {string} objectInstanceID - The ID of the object instance.
     * @param {array} existingSubObjectIDList - A list of existing sub-object IDs.
     * @return {void}
     */
    commitDone(objectInstanceID, existingSubObjectIDList) {
      if (objectInstanceID) {
        for (let i = 0; i < this.formularList.length; i++) {
          let fieldList = this.formularList[i].formularFields.formularFlatList
          for (let j = 0; j < fieldList.length; j++) {
            let field = fieldList[j]
            if (field.nativename === "oiID") {
              this.objInstanceID = objectInstanceID
              this.eventBus.setPropertyValue(field, objectInstanceID)
              this.eventBus.changeFormularField(this.formularList[i].id, field, objectInstanceID, false)
              // logger.info("oiID refresh. formID:", this.formularList[i].id, ", oiID:", objectInstanceID)
              //break
            }

            if (field.nativename === "iLastSavedFormularPage") {
              this.eventBus.setPropertyValue(field, field.value)
              this.eventBus.changeFormularField(this.formularList[i].id, field, field.value, false)
              // logger.info("iLastSavedFormularPage refresh. formID:", this.formularList[i].id, ", iLastSavedFormularPage:", field.value)
            }

            if (existingSubObjectIDList && existingSubObjectIDList.length > 0) {
              // logger.info("***** existingSubObjectIDList:", existingSubObjectIDList)
              existingSubObjectIDList.forEach(existingSubObject => {
                if (existingSubObject.nativename === field.nativename && existingSubObject.existingSubObjectIDs && existingSubObject.existingSubObjectIDs.length > 0) {
                  field.existingSubObjectIDs = existingSubObject.existingSubObjectIDs
                  field.subInstanceID = field.existingSubObjectIDs[0]
                  // logger.info("!!!! set existingSubObjectIDs for " + field.nativename + ":", field.existingSubObjectIDs)
                }
              })
            }
          }
        }
      }

      // logger.info("commitDone: ", this.btnCommitFunc)
      if (this.btnCommitFunc === 2) {
        // on button next - scroll next formular page top
        if (this.page < this.maxPages) {
          this.page++
          this.actEditTab = this.page
        }

        this.scrollToTop()
      }
      this.btnCommitFunc = 0 // 0 = Save, 1 = Apply
    },

    btnBack() {
      if (this.actEditTab > 0) this.actEditTab--
      this.page = this.actEditTab

      if (this.formPrefix && this.formPrefix.length > 0) {
        this.btnCommitFunc = 3
        this.onCommitParentFromEvent = true
        this.btnCommit()
        this.onCommitParentFromEvent = false
        if (this.page === this.formularList.length - 1) this.formPrefix[this.page].value = "<img class='chksvgForm' src='https://snippet.servoking.at/sitemedia/icons/sk_cancel_red.svg'/>"
      }

      this.btnNextDisabled = false
      if (this.isPopup) {
        this.$emit("initButtons", {
          page: this.page
        })
      }

      if (this.formPrefix && this.formPrefix.length >= this.page && this.formPrefix[this.page]) {
        this.formPrefix[this.page].value = "<img class='chksvgForm' src='https://snippet.servoking.at/sitemedia/icons/sk_cancel_red.svg'/>"
      }


      this.readonly = false
    },

    validateField(field, page) {
      if (field.validate) {
        field.setValid()

        if (field.renderOnFrontend && (field.showThroughDependency || typeof field.showThroughDependency === "undefined")) field.validate()

        if (field.invalid) {
          // if (field.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER) {
          console.warn("validate field ", field.title + " is invalid", field)
          this.paramsInvalid = true
          if (this.firstFieldWithError == null) this.firstFieldWithError = field // for setting cursor in first error field
          if (this.firstPageWithError == null) this.firstPageWithError = page
        }

        // upload files from fldFile fields
        const formStore = useFormularStore()
        if ((field.dataTypeID === StaticData.DATATYPES.TYPE_PHOTO || field.dataTypeID === StaticData.DATATYPES.TYPE_FILE) && field.value != null) {
          let classID = field.classID
          let uploadPromise = (resolve, reject) => {
            this.eventBus.uploadFileFormFields(classID, resolve, field.subtypeCount, field.possibleSubclassCounter)
          }
          logger.info("validateField, add uploadPromise for:", field.title, field.value, field)
          formStore.fileUploadPromises.push(uploadPromise)
        }
      }
      field.propertyInstanceValue = field.value // ? field.value : null
    },

    addUploadAndPreSafePromisesToField() {
      const formularStore = useFormularStore()
      this.preSafeFields = []
      this.formularList[this.page].formularFields.formularFlatList.forEach((field) => {
        let fieldValue = field.value ? field.value : ""
        if (field.renderOnFrontend && field.preSafeSqlProc && (field.showThroughDependency === true || typeof field.showThroughDependency === "undefined") && !(fieldValue.length === 0 && field.skipPresafe)) {
          //console.warn("call isPreSafeCheckOK for ", field.title, field)
          // if field has set a preSafeSql - add a 'isPreSafeCheckOK' service call to promise list...
          this.preSafePromises.push(formularStore.isPreSafeCheckOK({
            propertyClassID: field.classID,
            objClassID: field.formObjectClassID,
            propertyInstanceValue: field.value,
            formularList: this.formularList
          }))
          // store this field
          this.preSafeFields.push(field)
        }
      })

      //logger.info("authStore.fileUploadPromises:", authStore.fileUploadPromises)
    },

    gotoNextPage() {
      if (!this.paramsInvalid) {
        if (this.page < this.maxPages) {
          this.page++
        }
      } else {
        console.warn("Formular not sent. paramsInvalid set. Invalid field: ", this.firstFieldWithError.title)
        if (this.firstFieldWithError != null) this.eventBus.setFocus(this.firstFieldWithError.nativename)
      }
      this.btnNextDisabled = false
    },


    commitData() {
      logger.info("commitData")
      // check if there are only field valdiation errors of requiredMode lazy
      let invalidEagerReqModeFields = 0
      let invalidLazyReqModeFields = 0
      let invalidEmptyLazyReqModeFields = 0
      let invalidGeneralFields = 0
      let invalidSubforms = 0
      let frmCount = 0

      this.formularList.forEach((formList) => {
        let pageValid = true

        formList.formularFields.formularFlatList.forEach((field) => {
          //logger.info("formular checked: ", field.title, field.invalid, field.requiredMode)
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER) {
            logger.info("invalidEagerReqModeFields (commitData)=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value);
            pageValid = false
            invalidEagerReqModeFields++
          }
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
            pageValid = false
            invalidLazyReqModeFields++
            if (!field.value) invalidEmptyLazyReqModeFields++
            logger.info("invalidLazyReqModeFields (commitData)=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value, ', invalidEmptyLazyReqModeFields=', invalidEmptyLazyReqModeFields);
          }
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.NONE && field.dataTypeID !== StaticData.DATATYPES.TYPE_SUBCLASS && !field.errorFetchingData) {
            logger.info("invalidGeneralFields (commitData)=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value, field);
            pageValid = false
            invalidGeneralFields++
          }
          if (field.invalid && field.dataTypeID === StaticData.DATATYPES.TYPE_SUBCLASS) {
            pageValid = false
            invalidSubforms++
          }
        })
        //logger.info("formular validate status checked:", frmCount, ", pageValid:", pageValid)
        this.formularPageValid[frmCount] = pageValid
        frmCount++
      })

      //logger.info("validation result: invalidEagerReqModeFields=", invalidEagerReqModeFields, "invalidLazyReqModeFields=", invalidLazyReqModeFields, "invalidGeneralFields=", invalidGeneralFields, "invalidSubforms=", invalidSubforms, "paramsPreSaveInvalid", this.paramsPreSaveInvalid, ", this.formPrefix.length:", this.formPrefix.length)
      // (this.formPrefix.length === 0 || this.btnCommitFunc === 0)) {

      logger.info("commitData validation - formularPageValid[", this.page, "]):", this.formularPageValid[this.page], ", invalidEagerReqModeFields=", invalidEagerReqModeFields, "invalidGeneralFields:", invalidGeneralFields, "invalidSubforms:", invalidSubforms, ", invalidEmptyLazyReqModeFields:", invalidEmptyLazyReqModeFields, "paramsPreSaveInvalid:", this.paramsPreSaveInvalid, "formPrefix.length:", this.formPrefix.length, this.formularPageValid)

      if (this.onCommitParentFromEvent) {
        // logger.info("commitData 1 - commitFormularList")
        this.commitFormularList(invalidEagerReqModeFields === 0 && invalidGeneralFields === 0 && invalidLazyReqModeFields === 0 && invalidSubforms === 0)

      } else {
        if (invalidEagerReqModeFields === 0 && invalidGeneralFields === 0 && invalidSubforms === 0 && invalidEmptyLazyReqModeFields > 0 && !this.paramsPreSaveInvalid && this.formPrefix.length > 0 && !this.formularPageValid[this.page]) {
          // logger.info("commitData 2 - showEmptyLazyDialog valid error on this page")
          this.showEmptyLazyDialog(invalidEmptyLazyReqModeFields, false, this.objClassID)

        } else if (invalidEagerReqModeFields === 0 && invalidGeneralFields === 0 && invalidSubforms === 0 && invalidEmptyLazyReqModeFields > 0 && !this.paramsPreSaveInvalid && this.formPrefix.length === 0) {
          // logger.info("commitData 3 - showEmptyLazyDialog on first page")
          this.showEmptyLazyDialog(invalidEmptyLazyReqModeFields, false, this.objClassID)

        } else {
          if (invalidEagerReqModeFields === 0 && invalidGeneralFields === 0 && invalidSubforms === 0 && !this.paramsPreSaveInvalid) {
            // logger.info("commitData 4 - commitFormularList", invalidEagerReqModeFields, invalidGeneralFields, invalidLazyReqModeFields, invalidSubforms)
            this.commitFormularList(invalidEagerReqModeFields === 0 && invalidGeneralFields === 0 && invalidLazyReqModeFields === 0 && invalidSubforms === 0)

          } else {
            // logger.info("commitData 5 - Formular not sent. paramsInvalid set. Invalid field: ", this.firstFieldWithError.fieldgroupTitle, "|", this.firstFieldWithError.title)
            this.setFocusInFirstErrorField()
          }
        }
      }
    },

    showEmptyLazyDialog(invalidEmptyLazyReqModeFields, revalidate, objectClassID) {
      if (this.objClassID === objectClassID) {
        if (invalidEmptyLazyReqModeFields > 0) {
          if (!this.isShowingEmptyLazyDialog) {
            this.isShowingEmptyLazyDialog = true
            this.$q.dialog({
              title: this.$t('emptyFieldsDlgTitle'),
              message: this.$t('emptyFieldsDlgMessage'),
              ok: this.$t('ok'),
              cancel: this.$t('cancel'),
              style: "width:70%",
              html: true

            }).onOk(() => {
              this.isShowingEmptyLazyDialog = false
              if (revalidate) {
                this.revalidateAfterLazySubform();
              } else {
                // logger.info("*3")
                this.commitFormularList(false)
              }
            }).onCancel(() => {
              this.isShowingEmptyLazyDialog = false
              this.setFocusInFirstErrorField()
            })
          }
        } else {
          this.setFocusInFirstErrorField()
        }
      }
    },

    revalidateAfterLazySubform() {
      // revalidate after confirming lazy warning dialog form subforms
      let invalidEagerReqModeFields = 0
      let invalidGeneralFields = 0

      this.formularList.forEach((formList) => {
        formList.formularFields.formularFlatList.forEach((field) => {
          // logger.info("commitData check: ", field.title, field.invalid, field.requiredMode)
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER) {
            logger.info("invalidEagerReqModeFields revalidateAfterLazySubform=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value);
            invalidEagerReqModeFields++
          }
          if (field.invalid && field.requiredMode === StaticData.FORM_REQUIRED_MODES.NONE && field.dataTypeID !== StaticData.DATATYPES.TYPE_SUBCLASS) {
            logger.info("!!! invalidGeneralFields (revalidateAfterLazySubform)=", field.fieldgroupTitle, "|", field.title, ", reqMode=", field.requiredMode, ", value=", field.value);
            invalidGeneralFields++
          }
        })
      })

      if (invalidEagerReqModeFields === 0 && invalidGeneralFields === 0 && !this.paramsPreSaveInvalid) {
        // logger.info("*4")
        this.commitFormularList(invalidEagerReqModeFields === 0 && invalidGeneralFields === 0)
      } else {
        console.warn("Formular not sent. paramsInvalid set. Invalid field: ", this.firstFieldWithError.fieldgroupTitle, "|", this.firstFieldWithError.title)
        this.setFocusInFirstErrorField()
      }
    },

    onSubformularInvalidLazy(data) {
      if (!this.isSubtype) {
        this.showEmptyLazyDialog(data.invalidLazyinSub, true, data.objectClassID)
      }
    },

    setFocusInFirstErrorField() {
      this.$nextTick(() => {
        if (this.firstPageWithError != null) {
          //logger.info("setFocusInFirstErrorField - this.firstPageWithError:", this.firstPageWithError)
          this.page = this.firstPageWithError
          //logger.info("this.page:", this.page, ", this.firstPageWithError:", this.firstPageWithError)
          //logger.info("setFocus to ", this.firstFieldWithError.nativename, this.page)
          if (this.firstFieldWithError != null) this.eventBus.setFocus(this.firstFieldWithError.nativename, true)
        }
      })
    },

    commitFormularList(formularValid) {
      const formStore = useFormularStore()
      // logger.info("**** commitFormularList. formularValid: ", formularValid, ", page: ", this.page)

      if (this.multipleSubmitCount === 1) {
        this.$q.loading.show({message: this.$t('savingFormular')})
      } else {
        this.showMultiSubmitProgress = true
      }

      //logger.info("commit - check formStore.fileUploadPromises: ", formStore.fileUploadPromises.length, formStore.fileUploadPromises)

      if (formStore.fileUploadPromises.length > 0) {

        // File uploads correctly done
        let promiseUploadList = []
        for (let i = 0; i < formStore.fileUploadPromises.length; i++) {
          promiseUploadList.push(new Promise(formStore.fileUploadPromises[i]))
          logger.info("Add promise to promiseUploadList: ", i)
        }

        //logger.info("Start Promise.all. promiseUploadList: ", promiseUploadList)
        Promise.all(promiseUploadList)
          .then(response => {
            if (response != null) {
              // now store the formular data...
              logger.info("Promise.all done. page:" + this.page)
              this.persistFormular(this.objClassID, formularValid)
              formStore.fileUploadPromises = []
            }
          })
          .catch(error => {
            logger.info("fileUploadPromises error: ", error)
            //this.loading = false
            if (this.multipleSubmitCount === 1) {
              this.$q.loading.hide()
            } else {
              this.showMultiSubmitProgress = false
            }
            let errMsg = this.$t('fileUploadError')
            this.eventBus.globalErrorHandling(errMsg, error)
          })

      } else {
        // logger.info("-- No Promise.all needed")
        this.persistFormular(this.objClassID, formularValid)
      }
    },

    /**
     * Persists the formular to the backend.
     *
     * @param {string} objClassID - The object class ID.
     * @param {boolean} formularValid - Indicates whether the formular is valid or not.
     * @return {Promise} - A promise that resolves when the formular is persisted successfully.
     */
    async persistFormular(objClassID, formularValid) {
      //logger.info("--------------- persistFormular ---------------")
      const authStore = useFormularStore()

      let persistList = FormProperty.getFormularPersistFields(this.formularList)
      // logger.info("persistFormular - persistList:", persistList)

      // update or first insert?
      let isNewInsert = true

      // set invisible field values to null before persisting
      for (let i = 0; i < this.formularList.length; i++) {
        persistList[i].formularFields.formularFlatList = []
        let fieldList = this.formularList[i].formularFields.formularFlatList
        let tmpFieldList = []

        for (let j = 0; j < fieldList.length; j++) {
          let field = fieldList[j]

          if (field.nativename === "iLastSavedFormularPage") {
            // logger.info("persistFormular 0 - this.formularPageValid[this.page]: ", this.formularPageValid[this.page], this.page, this.formularPageValid)

            logger.info("persistFormular - this.btnCommitFunc: ", this.btnCommitFunc)

            switch (this.btnCommitFunc) {
              case 1:
                // on button APPLY / NEXT- lastsaved page is the same as actual - stay on page
                if (this.formularPageValid[this.page]) {
                  field.value = this.page
                  field.propertyInstanceValue = this.page
                  // logger.info("persistFormular 1 - set iLastSavedFormularPage to:", this.page)
                }
                break
              case 3:
                // on button BACK
                field.value = this.page
                field.propertyInstanceValue = this.page
                // logger.info("persistFormular 1 - set iLastSavedFormularPage to:", this.page)
                break
              default:
                // else increment und goto next formular
                if (this.formularPageValid[this.page]) {
                  field.value = this.page + 1
                  field.propertyInstanceValue = this.page + 1
                  // logger.info("persistFormular 2 - set iLastSavedFormularPage to:", this.page + 1)
                }
            }
          }

          if (!this.actionParameter.formCSS || field.cssClass === this.actionParameter.formCSS) {
            if (field.dataTypeID !== 16) {
              let pushField = FormProperty.createBackendFormProperty(field, isNewInsert)
              tmpFieldList.push(pushField)
            }
          }
        }
        persistList[i].formularFields.formularFlatList = tmpFieldList
      }

      for (let i = 0; i < this.multipleSubmitCount; i++) {
        //multiple query rows selected for form action, submit single form per selected row, values need to be adjusted per selected row for readonly fields
        if (this.multipleSubmitCount > 1) {
          let tmpFields = persistList[0].formularFields.formularFlatList
          for (let k = 0; k < tmpFields.length; k++) {
            //logger.info("!!! ", i, k, tmpFields[k].nativename, this.selectedMultiple[i][tmpFields[k].nativename])
            if (tmpFields[k].readonly && this.selectedMultiple[i][tmpFields[k].nativename]) {
              tmpFields[k].propertyInstanceValue = this.selectedMultiple[i][tmpFields[k].nativename]
            }
          }
          //tmpFields.forEach((x) => obj.formularFields.formularFlatList.push(Object.assign({}, x)))
          persistList[0].formularFields.formularFlatList = tmpFields
        }

        try {
          //const startTime = performance.now(); // Startzeit aufnehmen
          let respBlob = await authStore.persistFormularList({formularList: persistList, objClassID, formularValid, activeFormularList: this.activeFormularList})
          //const endTime = performance.now(); // Endzeit aufnehmen
          // logger.info(`persistFormularList Dauer: ${(endTime - startTime).toFixed(2)} ms`);

          this.eventBus.resetFormularEditState()

          if (i + 1 === this.multipleSubmitCount) {
            this.saveFormularValueInLocalStorage(this.formularList)
            this.processPluginResponse(respBlob)
            if (this.multipleSubmitCount === 1) {
              this.$q.loading.hide()
            } else {
              this.showMultiSubmitProgress = false
            }
          }
        } catch (error) {
          logger.info("Error persistFormularList:", error)
          if (i + 1 === this.multipleSubmitCount) {
            if (this.multipleSubmitCount === 1) {
              this.$q.loading.hide()
            } else {
              this.showMultiSubmitProgress = false
            }
            let errMsg = this.$t('formularPersistError')
            logger.info("!!!! error.sErrorMsg:", error.sErrorMsg)
            if (error.data && error.data.sErrorMsg) {
              errMsg = error.data.sErrorMsg
            }
            this.eventBus.globalErrorHandling(errMsg, error)
          }
        }
        this.multiSubmitCounter++
      }
    },

    pageBack() {
      this.setFormularRefererField()
      this.$emit('btnBack')
      // window.history.go(-1);
    },

    cancelPopup() {
      // typed input may still be waiting for the field debounce - it counts as unsaved input
      if (this.actionDialog && this.actionDialogDirty && !this.readonly && !this.actionReadonly) {
        this.$q.dialog({
          title: this.$t('formularNotSaved'),
          message: this.$t('formularNotSavedDesc'),
          ok: this.$t('yes'),
          cancel: this.$t('no'),
          style: "width:80%",
        }).onOk(() => {
          this.actionDialogDirty = false
          this.$emit('onFormularCancel')
        })
        return
      }
      this.$emit('onFormularCancel')
    },

    // action dialog: real keyboard input marks the form as changed immediately - field changes are
    // reported debounced (fldString 500 ms) and ignored shortly after loading, so Escape right after
    // typing would otherwise close without the unsaved-input question
    onUserInput(event) {
      if (this.actionDialog && event && event.isTrusted && !this.readonly && !this.actionReadonly) this.actionDialogDirty = true
    },


    setFormularRefererField() {
      if (!this.actionReadonly) {
        let sFormularReferer = null
        for (let i = 0; i < this.formularList.length; i++) {
          let fieldList = this.formularList[i].formularFields.formularFlatList
          for (let j = 0; j < fieldList.length; j++) {
            let field = fieldList[j]
            if (field.nativename === "sFormularReferer") {
              //logger.info("Formular.vue - pageBack, sFormularReferer: ", field.value)
              sFormularReferer = field.value
              break;
            }
          }
        }
        sessionStorage.setItem('sFormularReferer', sFormularReferer);
      }
    },

    successPageHandling(objectInstanceID, outputMsg, existingSubObjectIDList) {
      // logger.info("------------ successPageHandling")
      // logger.info("popupSuccessPage:", this.popupSuccessPage, ", formularClass.successPageUri:", this.formularClass.successPageUri)

      let successPage = this.popupSuccessPage ? this.popupSuccessPage : this.formularClass.successPageUri

      if (successPage === "None") successPage = null

      if (successPage && successPage !== "") {
        // replace placeholder with formular values
        let paramString = successPage.substring(successPage.indexOf("?") + 1)

        const successPageQueryParamList = new URLSearchParams(paramString);
        for (const param of successPageQueryParamList) {
          let paramValue = param[1].substr(1)
          this.formularList.forEach((formular) => {
            formular.formularFields.formularFlatList.forEach((field) => {
              if (field.nativename === paramValue) {
                successPage = successPage.replaceAll(param[1], field.value)
              }
            })
          })
        }
        //logger.info("Route to formular successPage: ", successPage)
        location.href = successPage

      } else {
        if (this.propAppMode || this.isPopup) {
          if (!this.onCommitParentFromEvent) {
            if (this.actionDialog) {
              // Apply keeps the dialog open: take over a new object instance ID so a further save updates it
              const keepOpen = this.btnCommitFunc === 1
              if (keepOpen) this.commitDone(objectInstanceID, existingSubObjectIDList)
              this.btnCommitFunc = 0
              this.actionDialogDirty = false
              this.$emit('onFormularPersisted', objectInstanceID, outputMsg, this.formularList, {keepOpen})
            } else {
              this.$emit('onFormularPersisted', objectInstanceID, outputMsg, this.formularList)
            }
          }
        } else {
          if (this.$route.query.pageForBack) {
            this.$route.query.pageAfterBack = this.$route.query.pageForBack
          }
          if (this.$route.query.pageAppForBack) {
            this.$route.query.pageAppAfterBack = this.$route.query.pageAppForBack
          }
          if (this.$route.query.aac || this.$route.query.ac) {
            this.$route.query.deleteAction = 1
          }

          this.setFormularRefererField()

          if (this.postAction === StaticData.ACTION_POST_ACTION_BEHAVIOUR.QUERY_NEW_EXECUTE) {
            let detailQueryKeyValue = []
            for (let param in this.queryParameter) {
              let newParam = {name: param, value: this.queryParameter[param]}
              detailQueryKeyValue.push(newParam)
            }

            this.$router.push({
              name: 'Query',
              params: {
                id: this.queryID
              },
              state: {
                detailQueryKeyValue,
                autoSkipParameter: true
              },
              query: {page: 1, ...this.$route.query}
            })

          } else {
            //logger.info("this.formPrefix.length:", this.formPrefix.length)
            //logger.info("this.btnCommitFunc:", this.btnCommitFunc)

            if (this.formPrefix.length < 2 || this.btnCommitFunc === 0) { // btnCommitFunc 0 = Save, 1 = Apply, 3 = Back
              if (history.state && history.state.actionResultNewTab && !history.state.back) {
                // #897: formular opened as action result in a new tab - no history to go back to,
                // show the calling query in this tab instead (the opener tab stays untouched)
                this.$router.replace({name: 'Query', params: {id: this.queryID}, query: {page: 1}})
              } else {
                this.$router.back() // no successPage defined - go history back...
              }
            } else {
              // pre process on btnNext...
              this.commitDone(objectInstanceID, existingSubObjectIDList)
            }
          }
        }
      }
    },

    saveFormularValueInLocalStorage(formularList) {
      formularList.forEach((formular) => {
        formular.formularFields.formularFlatList.forEach((field) => {
          if (field.mruFirst) {
            localStorage.setItem(this.queryID + "__" + field.nativename, field.value)
          } else {
            localStorage.removeItem(this.queryID + "__" + field.nativename)
          }
        })
      })
    },

    processPluginResponse(respBlob) {
      // get json response out of blob format (cause call response is always a blob)
      let reader = new FileReader();
      reader.onload = function () {
        this.processPluginResponseSuccessPage(reader.result)
      }

      // if (respBlob.data && respBlob.data.size > 0) reader.readAsText(respBlob.data);
      if (respBlob.data && respBlob.data.size > 0 && respBlob instanceof Blob) {
        reader.readAsText(respBlob.data)
      } else {
        this.processPluginResponseSuccessPage(respBlob.data)
      }
    },

    processPluginResponseSuccessPage(result) {
      let vm = this
      let resp = safeParseJSON(result);

      //logger.info("processPluginResponseSuccessPage. result: ", resp)

      let objectInstanceID = resp.objectInstanceID
      let existingSubObjectIDList = resp.existingSubObjectIDList

      //logger.info("--- existingSubObjectIDList: ", existingSubObjectIDList)

      switch (resp.iResult) {
        case 0:
          if (resp.sOutput && resp.sOutput === "") {
            vm.$q.notify({color: "positive", message: vm.$t('formularPersisted')})
            vm.successPageHandling(objectInstanceID, resp.sOutput, existingSubObjectIDList)
          } else {
            vm.showOutputMsgFromSQL(objectInstanceID, resp.sOutput, existingSubObjectIDList)
          }
          break

        case 1:
          vm.$q.notify({color: "positive", message: vm.$t('downloadSuccess')})
          vm.successPageHandling(objectInstanceID, resp.sOutput, existingSubObjectIDList)
          break

        default:
          vm.$q.dialog({
            title: vm.$t('pluginCallError'),
            message: resp.sErrorMsg,
            ok: vm.$t('ok'),
            style: "width:80%"
          }).onDismiss(() => {
            vm.successPageHandling(objectInstanceID, resp.sOutput, existingSubObjectIDList)
          })
      }
    },

    showOutputMsgFromSQL(objectInstanceID, outputMsg, existingSubObjectIDList) {
      // logger.info("showOutputMsgFromSQL:", objectInstanceID, outputMsg)

      if (outputMsg) {
        if (outputMsg.startsWith("toast://")) {
          let msg = outputMsg.replace("toast://", "")
          this.$q.notify({color: "positive", message: msg})

        } else if (outputMsg.startsWith("http://") || outputMsg.startsWith("https://")) {
          window.open(outputMsg, '_blank');

        } else if (outputMsg.startsWith("query://")) {
          // Jump to Query with given ID and parameter
          // Format: query://{xxx}?qp.myParm=4711&qp.mySecParm=0815
          let destQueryID = outputMsg.substr(8, 38)
          let parameter = outputMsg.substr(8 + 38 + 1)

          if (!this.isPopup) {
            this.$router.push({
              name: 'Query',
              params: {
                id: destQueryID,
              },
              state: {
                clearSelectedRow: false
              },
              query: URLHelper.parseQueryString(parameter)
            }).catch(err => {
            })
          }

        } else if (outputMsg.startsWith("error://") || outputMsg.startsWith("msg://")) {
          let dlgTitle = outputMsg.indexOf("error://") > -1 ? "Fehler" : ""
          let msg = outputMsg.replace("msg://", "").replace("error://", "")
          this.$q.dialog({
            title: dlgTitle,
            message: msg,
            ok: this.$t('ok'),
            style: "width:70%",
            html: true
          })
        }
      }

      // action dialog: an information message (msg://) is a successful save - the dialog is closed / kept as on Save / Apply
      if (!outputMsg || (!outputMsg.startsWith("error://") && (!outputMsg.startsWith("msg://") || this.actionDialog))) {
        this.successPageHandling(objectInstanceID, outputMsg, existingSubObjectIDList)
      }
    },

    checkPreSafeSQL(followupFunction) {
      // now call the preSafeChecks for all fields in preSafePromises list
      this.$q.loading.show({message: this.$t('validatingInputs')})
      Promise.all(this.preSafePromises)
        .then(response => {
          if (response != null) {
            // response is a list 'PreSafeCheckResponse' from backend (checkOK/errorMsg/frontEndMsg)
            response.forEach((resp) => {

              // find field in stored preSafeFields - so we get the fieldreference and call setValid with given status
              this.preSafeFields.forEach((field) => {
                let respData = safeParseJSON(resp.config.data)

                if (field.classID == respData.propertyClassID) {
                  if (!resp.data.checkOK) {
                    field.setError(resp.data.frontEndMsg)
                    //if (this.firstFieldWithError == null) {
                    this.firstFieldWithError = field
                    this.firstPageWithError = this.page
                    //}
                    this.paramsInvalid = true
                    this.paramsPreSaveInvalid = true
                  }
                  return
                }
              })
              this.$q.loading.hide()
            })
            //logger.info("PreSafeChecks done - paramsInvalid: ", this.paramsInvalid)
            if (followupFunction) {
              followupFunction()
            }
          }
        })
        .catch(error => {
          let errMsg = this.$t('presafeCheckError')
          this.$q.loading.hide()
          this.eventBus.globalErrorHandling(errMsg, error)
        })
    },

    onChangeField(data) {
      //logger.info("onChangeField data:", data)
      //logger.info("onChangeField formularList:", this.formularList)
      //logger.info("onChangeField data parentForm:", data.formProperty.parentForm)

      let found = false

      for (let i = 0; i < this.formularList.length; i++) {
        if (this.formularList[i].id === data.formID) {
          found = true;
          break;
        }
      }

      if (found) {
        //logger.info("Formular.vue onChangeField:", data.event, data.formProperty)
        this.onFieldValueChange(data.event, data.formProperty)
      } else {
        //console.error("Formular ", data.formID, " not found!", this.formularList)
      }
    },

    /**
     *  onFieldValueChange
     *  ----------------------------------------------------------------------------------------------------
     *  Event triggered by @input
     *  Build a key/value list of all current formularvalues in model
     *  Send objClassID, classID of event target field and formularvalues to 'valueListSQLChange' service
     *
     **/
    onFieldValueChange(changedParam, changedField) {
      //console.time("onFieldValueChange");
      if (this.actionDialog && this.actionDialogReady) this.actionDialogDirty = true

      // Add Prefix HTML to Formular Tab (if multiple Formularpages)
      // Prefix code must be the value of a field with nativename of the formular + "_prefix"
      if (changedField.nativename.indexOf("_prefix") > -1) {
        this.setFormularTitle(changedField)
        return
      }
      const formularStore = useFormularStore()
      // logger.info("onFieldValueChange changedParam: ", changedField.title, changedParam)
      // logger.info("onFieldValueChange changedField: ", changedField.title, changedField)
      if (changedField.showThroughDependency === true || changedField.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
        this.hideOrDisableDependentFields(changedParam.classID, changedParam.value, changedField)

        if (changedField.instantRefresh) {
          // this.btnNextDisabled = true
          this.eventBus.showCompSpinner(changedField.id, true)

          // 1st: get dependent fields
          let fieldKeyValueList = FormularHelper.getKeyValueListOfDependentFields(this.formularList, changedField)
          let allFieldList = FormularHelper.getAllFieldList(this.formularList)

          // 2nd: send list of objClassID / value pairs to 'compValueChange' service
          if (changedField && changedField.dataTypeID !== StaticData.DATATYPES.TYPE_SUBCLASS) {
            //logger.info("compValueChange:", changedParam.nativename)

            // merge prefilled parameters (from before query) to dependent field list
            fieldKeyValueList = this.mergePrefilledParams(fieldKeyValueList)

            const requestId = formularStore.startRequest();

            // formularStore.incrementPendingOperations()
            formularStore.compValueChange({
              objClassID: this.objClassID,
              sourceChangedNativename: changedParam.sourceChangedNativename,
              propertyTitle: changedField.title,
              propertyClassID: changedParam.classID,
              fieldKeyValueList: fieldKeyValueList,
              activeFormularList: this.activeFormularList
            })
              .then((fieldKeyValueListReturn) => {
                // 3rd: get back dependent key/value list (key=nativename, value=csv of values) of changedFieldClassID
                for (let keyValueOfField of fieldKeyValueListReturn) {

                  // logger.info("Formular changedField.nativename == keyValueOfField.key", changedField.nativename, "==", keyValueOfField.key)
                  if (changedField.nativename === keyValueOfField.key) continue


                  this.eventBus.refreshCompDefault(changedParam.parentClassID, keyValueOfField.key, keyValueOfField.value, keyValueOfField.defaultValue, keyValueOfField.errorMsg, keyValueOfField.errorMsg, this.subtypeCount, changedParam.nativename)

                  if (allFieldList[keyValueOfField.key]) {
                    let changedField = allFieldList[keyValueOfField.key]
                    let classID = changedField.classID
                    let newValue = keyValueOfField.value

                    if (changedField.dataTypeID === StaticData.DATATYPES.TYPE_STRING) {
                      // logger.info("hideOrDisableDependentFields: ", keyValueOfField.key, classID, "NEWValue:", newValue, "OLDValue:")
                      this.hideOrDisableDependentFields(classID, newValue, changedField)
                    }
                  }
                }
                this.eventBus.showCompSpinner(changedField.id, false)
                // formularStore.decrementPendingOperations()
                formularStore.endRequest(requestId);

              })
          } else {
            this.eventBus.showCompSpinner(false)
            // this.btnNextDisabled = false
          }

          if (this.isSubtype) {
            this.$emit('onChange', changedParam)
          }
        }
      }
    },

    hideOrDisableDependentFields(masterId, value, changedField) {
      let eventSent = false
      for (let i = 0; i < this.formularList.length; i++) {
        let fieldList = this.formularList[i].formularFields.formularFlatList
        for (let j = 0; j < fieldList.length; j++) {
          let field = fieldList[j]
          if (field.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.NONE && field.masterPropertyID === masterId) {
            if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {

              if (this.checkStringMatch(field.masterPropertyValueEnabled, value) || this.checkBooleanTextMatch(field, value, changedField) || this.checkMultipleDependant(field, value)) {
                field.showThroughDependency = true
                if (field.defaultValue && field.dataTypeID !== StaticData.DATATYPES.TYPE_PHOTO && field.dataTypeID !== StaticData.DATATYPES.TYPE_FILE) {
                  if (!field.value) field.value = this.getDefaultValue(field)
                }
              } else {
                field.showThroughDependency = false
                field.value = null
                field.propertyInstanceValue = null

                if (field.dataTypeID === StaticData.DATATYPES.TYPE_VALUELIST) {
                  /*
                                    if(field.nativename === "task_priority"){
                                      logger.info("hideOrDisableDependentFields: disable task_priority!")
                                    }
                  */
                  this.eventBus.clearValuelistSelection(field.nativename, this.subtypeCount)
                }
              }
              //force redraw of component
              let id = field.id
              field.id = ""
              field.id = id
              if (field.showThroughDependency) {
                this.recursiveShowDependent(field)
              } else {
                this.recursiveHideDependent(field)
              }
            } else if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.REQUIRED) {
              if (this.checkStringMatch(field.masterPropertyValueEnabled, value) || this.checkBooleanTextMatch(field, value, changedField) || this.checkMultipleDependant(field, value)) {
                field.requiredMode = StaticData.FORM_REQUIRED_MODES.EAGER
              } else {
                field.requiredMode = StaticData.FORM_REQUIRED_MODES.NONE
              }
            } else if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.READONLY) {
              if (this.checkStringMatch(field.masterPropertyValueEnabled, value) || this.checkBooleanTextMatch(field, value, changedField) || this.checkMultipleDependant(field, value)) {
                field.readonly = true
              } else {
                field.readonly = false
              }
            }
          } else if (field.dataTypeID === StaticData.DATATYPES.TYPE_SUBCLASS && !eventSent) {
            eventSent = true
            this.eventBus.hideOrDisableFieldsInSubclass(masterId, value, changedField)
          }
        }
      }
      if (this.isSubtype) {
        let formular = this.formularList
        this.formularList = []
        this.formularList = formular
      }
    }
    ,

    onHideOrDisableFieldsInSubclass(data) {
      if (this.isSubtype) {
        this.hideOrDisableDependentFields(data.masterId, data.value, data.changedField)
      }
    }
    ,

    onHideOrDisableForAllFields() {
      if (!this.isSubtype) {
        this.subclassEventcounter++
        if (this.subclassEventcounter == this.subclassTypecounter) {
          for (let x = 0; x < this.formularList.length; x++) {
            let formular = this.formularList[x]
            let fieldList = formular.formularFields.formularFlatList
            for (let i = 0; i < fieldList.length; i++) {
              if (fieldList[i].showThroughDependency == true || fieldList[i].masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
                this.hideOrDisableDependentFields(fieldList[i].classID, fieldList[i].defaultValue, fieldList[i])
              }
            }
          }
        }
      }
    }
    ,

    onIncrementSubtypeCount() {
      if (!this.isSubtype) {
        this.subclassTypecounter++
      }
    }
    ,

    onRefreshParentForm(data) {
      if (!this.isSubtype) {
        if (data.formProperty && data.formProperty.dataTypeID == StaticData.DATATYPES.TYPE_SUBCLASS) {
          data.formProperty.parentForm = FormProperty.formularListFlatListCompleteCopy(this.formularList)
          this.eventBus.continueButtonAdd(data.formProperty.nativename)
        }
      }
    }
    ,

    onDecrementSubtypeCount() {
      if (!this.isSubtype) {
        this.subclassTypecounter--
      }
    }
    ,

    checkStringMatch(fieldValEnabled, value) {

      // split value (hack for valuelist popupquery
      // if (value && value.indexOf("||") !== -1) {
      //   value = value.split("||")[1]
      // }

      let result = false
      if (value) {
        if (fieldValEnabled.startsWith("!")) {
          let valuePattern = fieldValEnabled.substring(1)
          if (valuePattern.indexOf("%") !== -1) {
            valuePattern = valuePattern.replaceAll("%", "")
            if (!value.startsWith(valuePattern)) {
              result = true
            }
          } else if (fieldValEnabled === "!\"\"" && value !== "") {
            result = true
          } else if (value !== valuePattern) {
            result = true
          }
        } else if (fieldValEnabled.indexOf("%") !== -1) {
          let valuePattern = fieldValEnabled.replaceAll("%", "")
          if (value.includes(valuePattern)) {
            result = true
          }
        } else if (fieldValEnabled === value) {
          result = true
        }
      } else {
        if ((fieldValEnabled === "\"\"" || fieldValEnabled === "''") && (typeof value === 'undefined' || value === null || value === "")) {
          result = true
        }
      }
      return result
    },

    checkBooleanTextMatch(field, value, changedField) {
      if (changedField) {
        if (changedField.dataTypeID === StaticData.DATATYPES.TYPE_BOOLEAN) {
          if (value === 1 || value === true || value === "true") {
            if (field.masterPropertyValueEnabled === changedField.textTrue) {
              return true
            }
          } else if (value === 0 || value === false || value === "false") {
            if (field.masterPropertyValueEnabled === changedField.textFalse) {
              return true
            }
          }
        }
      }
      return false;
    }
    ,

    checkMultipleDependant(field, value) {
      if (field.masterPropertyValueEnabled && field.masterPropertyValueEnabled.includes(';')) {
        let array = field.masterPropertyValueEnabled.split(';')
        for (let i = 0; i < array.length; i++) {
          if (this.checkStringMatch(array[i], value)) {
            return true
          }
        }
      }
      return false;
    }
    ,

    getDefaultValue(field) {
      let res = null;
      if (field.dataTypeID === StaticData.DATATYPES.TYPE_BOOLEAN) {
        let lresult = field.defaultValue
        if (lresult !== undefined && lresult != null) {
          lresult = lresult.toLowerCase()
        }
        if (lresult === "true" || lresult === "ja" || lresult === "1") res = "1"
        else if (lresult === "false" || lresult === "nein" || lresult === "0") res = "0"
        else res = "3"
      } else {
        res = field.defaultValue
      }
      return res
    }
    ,

    recursiveHideDependent(parentField) {
      for (let i = 0; i < this.formularList.length; i++) {
        let fieldList = this.formularList[i].formularFields.formularFlatList
        for (let j = 0; j < fieldList.length; j++) {
          let field = fieldList[j]
          if (field.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.NONE && field.masterPropertyID === parentField.id) {
            if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
              field.showThroughDependency = false
              field.value = null
              field.propertyInstanceValue = null
              if (field.dataTypeID === StaticData.DATATYPES.TYPE_VALUELIST) {

                /*if(field.nativename === "task_priority"){
                  logger.info("hideOrDisableDependentFields: disable task_priority!")
                }
*/
                //this.eventBus.clearValuelistSelection(field.nativename, this.subtypeCount)
              }
              //force redraw of component
              let id = field.id
              field.id = ""
              field.id = id
              this.recursiveHideDependent(field)
            } else if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.REQUIRED) {
              field.requiredMode = StaticData.FORM_REQUIRED_MODES.NONE
            } else if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.READONLY) {
              field.readonly = false
            }
          }
        }
      }
    }
    ,

    recursiveShowDependent(parentField) {
      for (let i = 0; i < this.formularList.length; i++) {
        let fieldList = this.formularList[i].formularFields.formularFlatList
        for (let j = 0; j < fieldList.length; j++) {
          let field = fieldList[j]
          if (field.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.NONE && field.masterPropertyID === parentField.id) {
            if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
              if (this.checkStringMatch(field.masterPropertyValueEnabled, parentField.value) || this.checkBooleanTextMatch(field, parentField.value, parentField) || this.checkMultipleDependant(field, parentField.value)) {
                field.showThroughDependency = true
                if (field.defaultValue && field.dataTypeID !== StaticData.DATATYPES.TYPE_PHOTO && field.dataTypeID !== StaticData.DATATYPES.TYPE_FILE) {
                  if (!field.value) field.value = this.getDefaultValue(field)
                  // if(field.nativename === "dwldContCheckIn") logger.info("-----2: " + field.value)
                }
              }
              //force redraw of component
              let id = field.id
              field.id = ""
              field.id = id
              if (field.showThroughDependency) {
                this.recursiveShowDependent(field)
              }
            } else if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.REQUIRED) {
              if (this.checkStringMatch(field.masterPropertyValueEnabled, parentField.value) || this.checkBooleanTextMatch(field, parentField.value, parentField) || this.checkMultipleDependant(field, parentField.value)) {
                field.requiredMode = StaticData.FORM_REQUIRED_MODES.EAGER
              }
            } else if (field.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.READONLY) {
              if (this.checkStringMatch(field.masterPropertyValueEnabled, parentField.value) || this.checkBooleanTextMatch(field, parentField.value, parentField) || this.checkMultipleDependant(field, parentField.value)) {
                field.readonly = true
              }
            }
          }
        }
      }
    }
    ,

    callAction0Plugin() {
      logger.info("Call Action0 Plugin ID: ", this.formularClass.customAction0PluginID, this.pluginList)
      logger.info("Call Action0 this.formularClass: ", this.formularClass)
      if (this.formularClass.customAction0PluginID) {
        this.pluginComponentQueryParams = this.formularClass.customAction0Parameter
        this.pluginComponent = this.pluginList[0].url
        logger.info("now set pluginComponent: ", this.pluginComponent, ", Param: ", this.formularClass.customAction0Parameter)
      }
    }
    ,

    showGroup(fieldgroupTitle, index) {
      let fieldList = this.formularList[index].formularFields.formularFlatList
      let minOneFieldVisible = false

      for (let i = 0; i < fieldList.length; i++) {
        if (fieldList[i].fieldgroupTitle === fieldgroupTitle) {
          if (fieldList[i].renderOnFrontend && (fieldList[i].showThroughDependency === true || fieldList[i].masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
            if (!this.actionParameter.formCSS || this.actionParameter.formCSS === fieldList[i].cssClass) {
              minOneFieldVisible = true
            }
          }
        }
      }
      return minOneFieldVisible
    }
    ,

    objectKeysToLowerCase(input) {
      if (input != null) {
        if (typeof input !== 'object') return input;
        if (Array.isArray(input)) return input.map(this.objectKeysToLowerCase);
        return Object.keys(input).reduce(function (newObj, key) {
          let val = input[key];
          if (val == null) val = ""
          let newVal = (typeof val === 'object') ? this.objectKeysToLowerCase(val) : val;
          newObj[key.toLowerCase()] = newVal;
          return newObj;
        }, {});
      } else {
        return null;
      }
    }
    ,

    hasFormularGroups(singleFormular) {
      singleFormular.drawnFieldGroups = []
      let result = false
      for (let i = 0; i < singleFormular.formularFields.formularFlatList.length; i++) {
        let field = singleFormular.formularFields.formularFlatList[i]
        if (field.fieldgroupTitle !== "") {
          result = true
          break
        }
      }
      return result
    }
    ,

    getGroupClass(field, topLevel = false) {
      let result = fieldGroupClass(field.cssClass, topLevel && this.singleGroupFullWidth)

      if (this.isSubtype) {
        result += "subTypeGroup"
      }
      return result
    },

    // track the available width of the formular itself (dialog, splitter, page) instead of the viewport
    observeFormularWidth() {
      const el = this.$refs.formLayout && this.$refs.formLayout.$el
      if (!el || el === this.formularWidthElement || typeof ResizeObserver === 'undefined') return
      if (!this.formularWidthObserver) {
        this.formularWidthObserver = new ResizeObserver(entries => {
          const entry = entries[entries.length - 1]
          if (entry) this.formularWidth = Math.round(entry.contentRect.width)
        })
      }
      if (this.formularWidthElement) this.formularWidthObserver.unobserve(this.formularWidthElement)
      this.formularWidthElement = el
      this.formularWidthObserver.observe(el)
      this.formularWidth = Math.round(el.getBoundingClientRect().width)
    },

    getFieldClass(singleFormular, field) {
      //class="col-sm-6 col-xs-12" :class="{'q-pa-sm': !isSubtype && !singleFormular.compressedView, 'q-px-sm': singleFormular.compressedView, subTypeField: isSubtype}"
      let result = "col-sm-6 col-xs-12 "
      if (field.cssClass && field.cssClass.includes("col-")) {
        result = field.cssClass + " "
      }
      if (this.isSubtype) {
        result += "subTypeField "
      }
      if (!this.isSubtype && !singleFormular.compressedView) {
        result += "q-pa-sm "
      }
      if (singleFormular.compressedView) {
        result += "q-px-sm"
      }
      return result
    },

    reload(manreload) {
      const formularStore = useFormularStore()
      formularStore.clear()

      this.btnNextDisabled = false
      this.firstFieldWithError = null
      this.paramsInvalid = false
      this.paramsPreSaveInvalid = false
      this.preSafePromises = []
      this.formularPageValid = []
      this.preSafeFields = []
      formularStore.fileUploadPromises.value = []
      this.subclassTypecounter = 0
      this.subclassEventcounter = 0
      this.onCommitParentFromEvent = false

      if (!this.isSubtype) {
        this.eventBus.resetFormularEditState()
      }

      this.$q.loading.show({message: this.$t('formularLoading')})

      // get paramFields from StoreffocusFieldNativename
      let parentForm = this.parentFormPointer && this.parentFormPointer.parentForm ? this.parentFormPointer.parentForm : null

      if (!this.objInstanceID && this.selectedRow) this.objInstanceID = this.selectedRow["oiID"]
      if (!this.objInstanceID) this.objInstanceID = this.queryParameter?.oiID // last try: "oiID" as Query Parameter?

      //logger.info("FORMULAR RELOAD oiID: ", this.objInstanceID, ", classID: ", this.origObjClassID)

      let preFillParameterList = this.mergePrefilledParams()

      // convert actionSetupToken from config string 'showForms={formID1},{formID2},{formID3}' to Array ['{formID1}','{formID2}','{formID3}']
      formularStore.formularListGet({objClassID: this.origObjClassID, objInstanceID: this.objInstanceID, parentForm, activeFormularList: this.activeFormularList, preFillParameterList})
        .then(() => {
          if (this.actionDialog) {
            // value changes while rendering / setting defaults are no user input
            this.actionDialogDirty = false
            this.actionDialogReady = false
            setTimeout(() => {
              this.actionDialogReady = true
            }, 1000)
          }
          // logger.info("****************** Formular selectedRow keys:", Object.keys(history.state.selectedRow).length)
          // logger.info("!!!!!! history.state.selectedRow:", history.state.selectedRow)
          // logger.info("propSelectedRow:", this.propSelectedRow)
          // logger.info("this.selectedRow:", this.selectedRow)

          // logger.info("State: ", history.state.data)
          this.formularClass = formularStore.formularClass
          this.pluginList = formularStore.pluginList
          this.btnTxtCommit = this.formularClass.buttontextCommit
          this.btnTxtBack = this.formularClass.buttontextBack
          this.btnTxtNext = this.formularClass.buttontextNext
          this.btnTxtApply = "Übernehmen"
          this.formPrefix = []

          this.formularList = formularStore.formularList

          if (this.formularList.length > 0) {
            this.objClassID = this.formularList[0].formobjectClassID
          }

          let selectedRowLC = this.objectKeysToLowerCase(this.selectedRow)
          let queryParameterLC = this.objectKeysToLowerCase(this.queryParameter)

          if (!this.isSubtype && !this.propAppMode && this.formularList.length > this.page) {
            // logger.info("---> ", this.formularList, this.page)
            document.title = PP_CONST.APP_THEME[PP_CONST.APP_ACTIVE].BROWSERTITLE + ' - ' + this.formularList[this.page].title
          }

          let focusFieldNativename = "";

          if (selectedRowLC && selectedRowLC["actionparameter"]) {
            let parsedAP = JSON.parse(selectedRowLC["actionparameter"])
            //logger.info("AP:", parsedAP.objClassID, '==', this.objClassID)
            if (parsedAP.objClassID === this.objClassID) {
              this.actionParameter = parsedAP
              logger.info("found valid actionParameter for objectClass ", this.objClassID, ", parsed actionParameter: ", parsedAP)
            }
          }

          for (let x = 0; x < this.formularList.length; x++) {
            let formular = this.formularList[x]
            let fieldList = formular.formularFields.formularFlatList

            for (let i = 0; i < fieldList.length; i++) {
              let formProperty = FormProperty.createFromFormProperty(fieldList[i])

              // forces formular field components no to send initial compValueChange event
              formProperty.noInitOnChange = formular.infoShort === "noInitOnChange"

              // set objInstanceID to formProperty - so each formular field component knows it is loaded with a given instance and no inital compValueChange event must be triggered
              if (this.objInstanceID) formProperty.objInstanceID = this.objInstanceID

              // --- set default value of field ---
              // if existent - set default value of formularfield to selected row from given resultset (name matching)
              if (selectedRowLC && selectedRowLC[formProperty.nativename.toLowerCase()]) { // selectedRow in lowercases
                formProperty.value = selectedRowLC[formProperty.nativename.toLowerCase()]
                formProperty.defaultValue = selectedRowLC[formProperty.nativename.toLowerCase()]
                formProperty.preFilled = true
                /*
                                if (formProperty.nativename.toLowerCase() === "assigned_partner_id") {
                                  logger.info("selectedRowLC von ", formProperty.nativename.toLowerCase(), ":", selectedRowLC[formProperty.nativename.toLowerCase()], "compare:", formProperty.nativename.toLowerCase())
                                }
                */

              } else if (queryParameterLC && queryParameterLC[formProperty.nativename.toLowerCase()]) { // selectedRow in lowercases
                //logger.info("found ", formProperty.nativename.toLowerCase(), "in queryParameterLC")
                formProperty.value = queryParameterLC[formProperty.nativename.toLowerCase()]
                formProperty.defaultValue = queryParameterLC[formProperty.nativename.toLowerCase()]
                formProperty.preFilled = true
              }

              if (typeof formProperty.fieldgroupTitle === "undefined") {
                formProperty.fieldgroupTitle = ""
              }

              // removed for teletec initial load of subformular with dependent string field loading default value by sql
              //if (this.subtypeCount > 0 && !selectedRowLC) {
              //formProperty.defaultValue = ""
              //formProperty.value = ""
              //}

              if (this.isSubtype) {
                formProperty.parentFormPointer = Object.assign({}, this.parentFormPointer)
                formProperty.subtypeCount = this.subtypeCount //count of formulars inside sub type
                formProperty.possibleSubclassCounter = this.parentFormPointer.possibleSubclassCounter //count of subclasses in parent formular
              }

              if (formProperty.nativename.indexOf("_prefix") > -1) {
                let prefValue = formProperty.defaultValue ? formProperty.defaultValue : formProperty.staticTextValue
                this.formPrefix.push({name: formProperty.nativename, value: formProperty.value ? formProperty.value : prefValue})
                // logger.info("check: ", formular, formProperty.nativename, "==", (formular.name + "_prefix"))
                //logger.info("add:", formProperty.nativename)
              }

              switch (formProperty.dataTypeID) {
                case StaticData.DATATYPES.TYPE_INT:
                case StaticData.DATATYPES.TYPE_LONG:
                case StaticData.DATATYPES.TYPE_INT64:
                  formProperty.component = "fldNumber";
                  break;

                case StaticData.DATATYPES.TYPE_FLOAT:
                case StaticData.DATATYPES.TYPE_DOUBLE:
                  formProperty.component = "fldFloat";
                  break;

                case StaticData.DATATYPES.TYPE_STRING:
                case StaticData.DATATYPES.TYPE_MEMO:
                  formProperty.component = "fldString"
                  if (formProperty.defaultValue &&
                    (formProperty.defaultValue.includes("formular://") ||
                      formProperty.defaultValue.includes("query://") ||
                      formProperty.defaultValue.includes("cat://"))) {
                    this.$nextTick(() => {
                      // logger.info("---------------> ", formProperty.title, " add parentForm!")
                      formProperty.parentForm = this.formularList
                    })
                  }

                  if (formProperty.defaultValue && formProperty.defaultValue.includes("script://")) {
                    formProperty.component = "fldScript"
                  }

                  if (formProperty.defaultValue && formProperty.defaultValue.includes("address://")) {
                    formProperty.component = "fldAddressGmapMeshup"
                  }
                  break

                case StaticData.DATATYPES.TYPE_STATIC_TEXT:
                  formProperty.component = "fldString"
                  formProperty.readonly = true
                  if (formProperty.defaultValue &&
                    (formProperty.defaultValue.includes("formular://") ||
                      formProperty.defaultValue.includes("query://") ||
                      formProperty.defaultValue.includes("cat://") ||
                      formProperty.defaultValue.includes("qrcode://"))) {
                    formProperty.readonly = false
                  }
                  this.$nextTick(() => {
                    formProperty.parentForm = this.formularList
                  })

                  if (formProperty.defaultValue && (formProperty.defaultValue.includes("script://") || formProperty.defaultValue.includes("btnscript://"))) {
                    formProperty.component = "fldScript"
                  }
                  break;

                case StaticData.DATATYPES.TYPE_BOOLEAN:
                  formProperty.component = "fldCheckbox"
                  break;

                case StaticData.DATATYPES.TYPE_DATE:
                case StaticData.DATATYPES.TYPE_TIME:
                case StaticData.DATATYPES.TYPE_DATETIME:
                  formProperty.component = "fldDateTime"
                  break;

                case StaticData.DATATYPES.TYPE_VALUELIST:
                  formProperty.component = "fldValueList"
                  break;


                case StaticData.DATATYPES.TYPE_AUTOCOMPLETE:
                  formProperty.component = "fldAutocomplete"
                  // logger.info("fldAutocomplete: ", formProperty.nativename, formProperty.value, formProperty.defaultValue)
                  break;

                case StaticData.DATATYPES.TYPE_FILE:
                case StaticData.DATATYPES.TYPE_PHOTO:
                  formProperty.component = "fldFile"
                  break;

                case StaticData.DATATYPES.TYPE_SIGNATURE_FIELD:
                  formProperty.component = "fldSignature"
                  break;

                /*
                                case StaticData.DATATYPES.TYPE_INDIVIDUAL:
                                  if (formProperty.datatypeJVClass && formProperty.datatypeJVClass.includes("script://")) {
                                    formProperty.component = "fldScript"
                                  }
                                  break;
                */

                case StaticData.DATATYPES.TYPE_SUBCLASS:
                  formProperty.component = "fldSubtype"
                  formProperty.parentForm = FormProperty.formularListFlatListCompleteCopy(this.formularList)
                  if (formProperty.existingSubObjectIDs && formProperty.existingSubObjectIDs.length > 0) {
                    this.subclassTypecounter += formProperty.existingSubObjectIDs.length
                  } else if (formProperty.initialBehavior === StaticData.SUBFORM_INITIAL_BEHAVIOR.BUTTON_AND_FORM) {
                    this.subclassTypecounter++
                  }
                  formProperty.possibleSubclassCounter = this.possibleSubclassCounter
                  this.possibleSubclassCounter++
                  break;

                case StaticData.DATATYPES.TYPE_TICKET:
                case StaticData.DATATYPES.TYPE_TOKEN:
                  formProperty.component = "fldTicket"
                  break;

                case StaticData.DATATYPES.TYPE_RICHTEXT:
                  formProperty.component = "fldRichtext"
                  break;
              }

              //formProperty.readonly = false
              if (!this.isSubtype || this.isSubtype && this.focusInSubtype) {
                formProperty.autofocus = (i === 0) ? true : false
              }
              formProperty.invalid = false
              //logger.info("formProperty.nativename:",formProperty.nativename,",this.selectedRow[formProperty.nativename]:",this.selectedRow[formProperty.nativename])

              this.maxPages = this.formularList.length

              try {
                if (this.$route.query["page"]) {
                  let qpPage = parseInt(this.$route.query["page"]) - 1
                  if (qpPage >= this.minPages && qpPage < this.maxPages) {
                    this.page = qpPage;
                  }
                }
              } catch (e) {
                console.error(e)
              }

              if (formProperty.classID === formular.focusControl) focusFieldNativename = formProperty.nativename
            }
          }

          if (this.isPopup) {
            this.$emit("initButtons", {
              btnTxtCommit: this.formularClass.buttontextCommit,
              btnTxtBack: this.formularClass.buttontextBack,
              btnTxtNext: this.formularClass.buttontextNext,
              maxPages: this.maxPages
            })
          }

          this.appendScriptElementsToDocument()

          this.keyFormular++ // refresh formular, reset autofocus

          if (!this.isSubtype || this.isSubtype && this.focusInSubtype) {
            if (focusFieldNativename !== "") {
              this.$nextTick(() => {
                this.eventBus.setFocus(focusFieldNativename, true)
              })
            }
          }

          if (this.isSubtype) {
            this.eventBus.hideOrDisableForAllFields()
          }

          // hide or disable dependant fields for every field after they are mounted and have the correct value
          this.$nextTick(() => {
            for (let x = 0; x < this.formularList.length; x++) {
              let formular = this.formularList[x]
              let fieldList = formular.formularFields.formularFlatList

              for (let i = 0; i < fieldList.length; i++) {
                this.hideOrDisableDependentFields(fieldList[i].classID, fieldList[i].value, fieldList[i])
              }
            }
          })

          this.$q.loading.hide()

          this.$nextTick(() => {
            //logger.info("---- this.popupAutoclose:", this.popupAutoclose)
            if (this.popupAutoclose) {
              //logger.info("do btnCommit cause autclose")
              this.btnCommit()
            }

            this.actEditTab = this.getActiveTab()
            this.page = this.actEditTab

            // logger.info("Reload - actEditTab: ", this.actEditTab, ", page: ", this.page)
            // console.log("1: ", this.formularList, this.page)
            // console.log("getFilteredFormularFields(formularList[page]): ", this.getFilteredFormularFields(this.formularList[this.page]))

          })
        })
        .catch(error => {
          this.$q.loading.hide()
          let errMsg = this.$t('formularLoadingError')
          console.error(error)
          this.eventBus.globalErrorHandling(errMsg, error)
        })

      this.calcContentHeight()
    },

    /**
     * Merge pre-filled parameters with the given dependentKeyValueList.
     *
     * @param {Array} dependentKeyValueList - The list of dependent key-value pairs to merge.
     * @return {Array} - The merged list of key-value pairs.
     */
    mergePrefilledParams(dependentKeyValueList) {
      let result = dependentKeyValueList
      if (!result) result = []

      if (this.selectedRow) {
        Object.keys(this.selectedRow).forEach((key) => {
          if (!result.find(keyval => keyval.key === key)) {
            result.push({key: key, value: this.selectedRow[key]})
            //logger.info("add prefillParam selRow: ", key, "=", this.selectedRow[key])
          }
        })
      }

      //logger.info("--- now merge queryParameter:", this.queryParameter)
      if (this.queryParameter) {
        Object.keys(this.queryParameter).forEach((key) => {
          if (!result.find(keyval => keyval.key === key)) {
            result.push({key: key, value: this.queryParameter[key]})
            //    logger.info("add prefillParam qp: ", key, "=", this.queryParameter[key])
          }
        })
      }

      const authStore = useAuthStore()
      let deepLinkParam = authStore.queryParamListFromDeepLink
      //logger.info("--- now merge deepLinkParam:", deepLinkParam)

      if (deepLinkParam) {
        Object.keys(deepLinkParam).forEach((key) => {
          if (!result.find(keyval => keyval.key === key)) {
            result.push({key: key, value: deepLinkParam[key]})
            //    logger.info("add prefillParam dlp: ", key, "=", deepLinkParam[key])
          }
        })
      }

      return result
    },

    refreshDetailView() {
      this.reload(1)
    },

    getFormularTab(formular) {
      let result = formular.title
      let frmPrefix = this.formPrefix.filter(entry => entry.name.replace("_prefix", "") === formular.name)
      if (frmPrefix.length > 0) result = (frmPrefix[0].value ? frmPrefix[0].value + " " : "") + formular.title
      if (result != null) {
        result = CSVHelper.removeTextBetweenDoublePipe(result)
        result = CSVHelper.removeWordsWithColon(result)
      }
      return result
    },

    replaceFieldPlaceholder(text) {

      let result = text
      if (result && result.indexOf(":") !== -1) {
        this.formularList.forEach((formList) => {
          formList.formularFields.formularFlatList.forEach((field) => {
            if (!field.propertyInstanceValue) field.propertyInstanceValue = field.value
            if (field.propertyInstanceValue) {
              result = result.replaceAll(":" + field.nativename, field.propertyInstanceValue)
            }
          })
        })

        // remove placeholder fieldnames which could net replaced (not found)
        if (result.indexOf("||") !== -1 && result.indexOf(":") !== -1) {
          result = CSVHelper.removeTextBetweenDoublePipe(result)
        }

        // hack: remove formular title (SK)
        if (result.indexOf("||")) {
          let replTitle = result.substring(result.indexOf("||"))
          if (replTitle.indexOf("''") === -1) result = replTitle
          else result = result.replaceAll("''", "")
        }

        result = CSVHelper.removeWordsWithColon(result)
        result = result.replaceAll("||", "")
      }
      return result
    }
    ,

    setFormularTitle(field) {
      let frmPrefix = this.formPrefix.filter(entry => entry.name === field.nativename)
      if (frmPrefix.length > 0) frmPrefix[0].value = field.value
    }
    ,

    appendScriptElementsToDocument() {
      setTimeout(() => {
        //logger.info("APPEND Script Elements for Formular")
        let sParent = "frmContent_" + this.objClassID

        // logger.info('trying to find script tags in ', sParent)
        let frmParent = document.getElementById(sParent)
        let scriptList = []

        if (frmParent != null) {
          let domEntryText = frmParent.getElementsByClassName("entryText")

          if (domEntryText.length > 0) {
            domEntryText = domEntryText[0]

            // logger.info("domEntryText: ", domEntryText)
            scriptList = domEntryText.getElementsByTagName('script')

            // logger.info(`found total of ${scriptList.length} script(s)...`, scriptList)

            let scriptSourceListDefine = []
            let scriptSourceListUse = []

            for (let i = 0; i < scriptList.length; i++) {
              if (!!scriptList[i].src) {
                scriptSourceListDefine.push(scriptList[i])
              } else {
                scriptSourceListUse.push(scriptList[i])
              }
            }

            //logger.info("add scripts to dom: ", scriptSourceListUse)
            for (let i = 0; i < scriptSourceListDefine.length; i++) {
              let source = scriptSourceListDefine[i].src
              let newScriptElementDefiningSource = document.createElement('script')
              newScriptElementDefiningSource.setAttribute('type', 'text/javascript')
              newScriptElementDefiningSource.src = source
              newScriptElementDefiningSource.addEventListener('load', () => {
              })
              document.body.appendChild(newScriptElementDefiningSource)
            }

            for (let i = 0; i < scriptSourceListUse.length; i++) {
              let code = scriptSourceListUse[i].text
              let newScriptElementUsingSource = document.createElement('script')
              newScriptElementUsingSource.setAttribute('type', 'text/javascript')
              newScriptElementUsingSource.appendChild(document.createTextNode(code))
              document.body.appendChild(newScriptElementUsingSource)
            }
          }
        } else {
          console.warn('no parent container found')
        }
      }, 100)
    }
    ,

// get Array from config string
    getActiveFormularList(actionSetupToken) {
      // logger.info("getActiveFormularList: ", actionSetupToken)
      let result = null

      if (actionSetupToken) {
        let configName = "activeFormularList"
        const configRegex = new RegExp(`${configName}=([^;]+)`);
        const match = actionSetupToken.match(configRegex);

        /*
                logger.info("actionSetupToken: ", actionSetupToken)
                logger.info("match: ", match)
        */

        if (match) {
          let actFrmConfig = JSON.parse(match[1])
          //logger.info("actFrmConfig: ", actFrmConfig)

          let actFormListObjClass = Object.keys(actFrmConfig)[0];
          //logger.info("objClassID this frorm vs. actFrmConfig: ", actFormListObjClass, "==", this.objClassID)

          if (this.objClassID === actFormListObjClass) {
            result = actFrmConfig[actFormListObjClass]
            //logger.info("objClassID of actFrmConfig matched.")
          }
        }
      }
      //logger.info("result act. forms: ", result)
      return result
    }
    ,

    clickFrmTitleButton(btnNativenameToClick) {
      /*
            if (btnNativenameToClick === 'btnTTToggle') {
              const isRunning = this.isTTTaskRunning === '1'
              const action = isRunning ? 'stoppen' : 'starten'

              this.$q.dialog({
                title: 'Zeitaufzeichnung',
                message: `Möchten Sie die Zeitaufzeichnung ${action.toLowerCase()}?`,
                cancel: {
                  label: 'Abbrechen',
                  flat: true,
                  color: 'grey'
                },
                ok: {
                  label: action === 'starten' ? 'Starten' : 'Stoppen',
                  color: 'primary'
                }
              }).onOk(() => {
                this.eventBus.clickFrmTitleButton(btnNativenameToClick)
              })
            } else {
              this.eventBus.clickFrmTitleButton(btnNativenameToClick)
            }
      */
      this.eventBus.clickFrmTitleButton(btnNativenameToClick)
    },

    calcContentHeight() {
      const dialogHeight = this.isPopup && !this.isSubtype ? dialogAvailableHeight(this.$el) : null
      if (dialogHeight !== null && !this.propHeight) {
        this.contentHeight = dialogHeight
        this.checkScrollable()
        return
      }
      this.contentHeight = 450
      if (this.propHeight) this.contentHeight = this.propHeight
      else {
        let wndHeight = window.innerHeight
        let offset = this.$q.platform.is.mobile ? 50 : 55

        // check if this formular is part of a dashboard (if q-splitter is parent)
        let isChildOfDashboard = DOMHelper.isChildOfElementWithClass(document.getElementById('frmContent_' + this.objClassID), "q-splitter")
        let isChildOfPopupWindow = document.getElementById('popup_')

        if (isChildOfDashboard) {
          wndHeight = document.getElementById('frmContent_' + this.objClassID).parentNode.clientHeight
          offset = 0

        } else if (isChildOfPopupWindow) {
          let dlgParent = document.getElementById('popup_');
          let dlgBody = dlgParent.querySelector('.dlgBody');
          wndHeight = dlgBody.offsetHeight + 30
        }

        let dashboardMaximizedOffset = 0
        let dashboardHeaderMaximizedOffset = 0

        if (this.dashboardMaximized) {
          dashboardMaximizedOffset = 10
          if (this.dashboardHeaderProp) {
            dashboardHeaderMaximizedOffset = 110
          }
        }

        this.contentHeight = wndHeight - offset - dashboardMaximizedOffset - dashboardHeaderMaximizedOffset


        this.checkScrollable()

        // logger.info("calcContentHeight wndHeight:", wndHeight, "- offset:", offset, "- dashboardMaximizedOffset:", dashboardMaximizedOffset, "- dashboardHeaderMaximizedOffset:", dashboardHeaderMaximizedOffset)
        //logger.info("calcQueryTableHeight:", myHeight)
        // })
      }
    }
  },

  beforeUnmount: function () {
    if (this.actionDialog && this.isPopup && this.actionDialogDirty) this.$emit('initButtons', {formDirty: false})
    this.eventBus.off('refreshDetailView', this.refreshDetailView)
    this.eventBus.off('onHideOrDisableFieldsInSubclass', this.onHideOrDisableFieldsInSubclass)
    this.eventBus.off('onHideOrDisableForAllFields', this.onHideOrDisableForAllFields)
    this.eventBus.off('onSubformularInvalidLazy', this.onSubformularInvalidLazy)
    this.eventBus.off('onIncrementSubtypeCount', this.onIncrementSubtypeCount)
    this.eventBus.off('onDecrementSubtypeCount', this.onDecrementSubtypeCount)
    this.eventBus.off('onRefreshParentForm', this.onRefreshParentForm)
    this.eventBus.off('onChangeFormularField', this.onChangeField)
    this.eventBus.off('resizeContentWindow', this.calcContentHeight)
    this.eventBus.off('onFormularApply', this.btnApply)
    this.eventBus.off('onToggleCollapseAllPanels', this.onToggleCollapseAllPanels)
    window.removeEventListener('resize', this.calcContentHeight)
    if (this.formularWidthObserver) this.formularWidthObserver.disconnect()
    this.formularWidthObserver = null
    this.formularWidthElement = null
  },

  updated() {
    this.observeFormularWidth()
  },

  mounted() {
    // this.activeFormularList = this.getActiveFormularList(history.state.actionSetupToken)

    this.origObjClassID = this.objClassID
    this.multipleSubmitCount = (this.selectedMultiple && Array.isArray(this.selectedMultiple)) ? this.selectedMultiple.length : 1
    if (this.multipleSubmitCount === 0) this.multipleSubmitCount = 1

    //logger.info("Mount Formular. readOnly:", this.readOnly, ", selectedMultiple:", this.selectedMultiple, ", selected count: ", this.multipleSubmitCount )

    // logger.info("Formular mount. Route.", this.$route)
    this.eventBus.on('refreshDetailView', this.refreshDetailView)
    this.eventBus.on('onHideOrDisableFieldsInSubclass', this.onHideOrDisableFieldsInSubclass)
    this.eventBus.on('onSubformularInvalidLazy', this.onSubformularInvalidLazy)
    this.eventBus.on('onIncrementSubtypeCount', this.onIncrementSubtypeCount)
    this.eventBus.on('onDecrementSubtypeCount', this.onDecrementSubtypeCount)
    this.eventBus.on('onRefreshParentForm', this.onRefreshParentForm)
    this.eventBus.on('onChangeFormularField', this.onChangeField)
    this.eventBus.on('resizeContentWindow', this.calcContentHeight)
    this.eventBus.on('onFormularApply', this.btnApply)
    this.eventBus.on('onToggleCollapseAllPanels', this.onToggleCollapseAllPanels)
    window.addEventListener('resize', this.calcContentHeight)

    setTimeout(this.checkScrollable, 500)
    this.$nextTick(this.observeFormularWidth)

    this.reload()
  },
}
</script>

<style lang="sass">
.formular
  padding-top: 5px

.sticky-footer
  position: sticky !important
  bottom: 0
  z-index: 2000
  background-color: inherit
  margin-top: auto

.fixed-bottom-footer
  position: fixed !important
  bottom: 0
  width: 100%
  left: 0
  z-index: 2000
  background-color: inherit
  margin-top: auto

.q-footer:not(.sticky-footer):not(.fixed-bottom-footer)
  position: relative !important


.frmH3
  font-size: 1.7em
  line-height: 1em
  margin: 0.6em 7px 10px 7px

.entryText
  margin: 0.5em 7px 10px 7px

.frmH3sm
  color: #777
  font-size: 1.4em
  line-height: 0.5em
  margin: 5px 10px 5px 3px

.entryTextsm
  margin: 10px 3px 5px 3px
  color: #777

.myField
  margin-bottom: 15px

.cardTitle
  font-weight: bold
  color: #666

.subType
  min-height: 0px !important
  padding: 0px !important

.subTypeField
  padding-right: 16px

.q-field__bottom
  padding-top: 3px

.q-field__messages
  padding-bottom: 10px

//.fldReq .q-field__control
//  background-color:  #E9D9D9


.fldReq .q-field__label
  font-weight: bold


.roRow
  width: 100%

.roLabel
  vertical-align: top
  font-weight: bold
  width: 50%
  display: inline-block

.roValue
  width: 50%
  display: inline-block

// ----------- field formatter styles

.fld-col1
  width: 10% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col1
  padding: 6px 0 6px 10px

.fld-col2
  width: 20% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col2
  padding: 6px 0 6px 10px

.fld-col3
  width: 30% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col3
  padding: 6px 0 6px 10px

.fld-col4
  width: 40% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col4
  padding: 6px 0 6px 10px

.fld-col5
  width: 50% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col5
  padding: 6px 0 6px 10px

.fld-col6
  width: 60% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col6
  padding: 6px 0 6px 10px

.fld-col7
  width: 70% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col7
  padding: 6px 0 6px 10px

.fld-col8
  width: 80% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col8
  padding: 6px 0 6px 10px

.fld-col9
  width: 90% !important
  float: left
  padding-right: 10px
  overflow: hidden

button.fld-col9
  padding: 6px 0 6px 10px

.fld-clear
  clear: both

.custom-dropdown .q-btn-dropdown__arrow-container
  display: none


.frmCard
  width: 100%
  height: 100%
  overflow: hidden
  background-color: color-mix(in srgb, var(--q-primary) 2%, transparent)
  border: 1px solid color-mix(in srgb, var(--q-primary) 30%, transparent)
  border-radius: 5px
  background-color: white
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)

  .panelHeaderStyle
    background-color: color-mix(in srgb, var(--q-primary) 70%, transparent)
    color: white !important


.panelSubHeaderStyle
  // background-color: #aaa
  background-color: color-mix(in srgb, var(--q-primary) 70%, transparent)
  color: white !important

.frmSubCard
  width: 100%
  height: 100%
  overflow: hidden
  border: 1px solid #ccc
  border-radius: 5px
  background-color: white
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)

  .frmCard
    background-color: color-mix(in srgb, var(--q-primary) 2%, transparent)
    outline: 1px solid color-mix(in srgb, var(--q-primary) 30%, transparent)
    border: none
    border-radius: 0

  .panelHeaderStyle
    border: none
</style>
